import React, { useEffect, useState, useMemo } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    Checkbox,
    ListItemText,
    TableRow,
    Paper,
    Snackbar,
    Alert,
    Menu,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Box,
    Chip,
    IconButton,
    Tooltip,
    Typography,
    Divider,
    TablePagination,
    InputAdornment,
    CircularProgress,
    Modal,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    useTheme,
} from "@mui/material";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getToken, isValidAdminToken } from "../utils/Authe";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LoginIcon from '@mui/icons-material/Login';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningIcon from '@mui/icons-material/Warning';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ControlPanel = () => {
    // States
    const theme = useTheme();
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const [removeFolderModalOpen, setRemoveFolderModalOpen] = useState(false);
    const [selectedFolderForRemove, setSelectedFolderForRemove] = useState(null);
    const [selectedStudentsForRemove, setSelectedStudentsForRemove] = useState([]);

    const [anchorEl, setAnchorEl] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("error");
    const [folderSearch, setFolderSearch] = useState("");
    const [folderPage, setFolderPage] = useState(0);
    const [folderRowsPerPage, setFolderRowsPerPage] = useState(5);
    const [selectedFolderForAssign, setSelectedFolderForAssign] = useState(null);
    const [assignFolderModalOpen, setAssignFolderModalOpen] = useState(false);
    const [selectedStudentsForFolder, setSelectedStudentsForFolder] = useState([]);
    const [activeTab, setActiveTab] = useState("student");
    const [selectedFolders, setSelectedFolders] = useState([]);
    const [students, setStudents] = useState([]);
    const [folders, setFolders] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [removeModalOpen, setRemoveModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [studentPage, setStudentPage] = useState(0);
    const [studentRowsPerPage, setStudentRowsPerPage] = useState(5);
    const [studentSearch, setStudentSearch] = useState("");
    const [quizResults, setQuizResults] = useState(null);
    const [quizModalOpen, setQuizModalOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [studentToDelete, setStudentToDelete] = useState(null);
    const [loginDetails, setLoginDetails] = useState(null);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [quizPage, setQuizPage] = useState(0);
    const [quizRowsPerPage, setQuizRowsPerPage] = useState(5);
    const [expandedFolder, setExpandedFolder] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editStudent, setEditStudent] = useState(null);
    const [formData, setFormData] = useState({
        student_name: "",
        student_email: "",
        password: "",
        confirmPassword: "",
    });

    const [foldersLoading, setFoldersLoading] = useState(true);
    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const [exportQaModalOpen, setExportQaModalOpen] = useState(false);
    const [selectedFoldersForExport, setSelectedFoldersForExport] = useState([]);
    const [importFolderModalOpen, setImportFolderModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const [importSuccessDialogOpen, setImportSuccessDialogOpen] = useState(false);
    const [importDetails, setImportDetails] = useState(null);


    const handleExportTemplate = async () => {
        try {
            const token = getToken();
            const response = await fetch(
                `${API_BASE_URL}/export/questions/template/`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`Export template failed: ${response.status} ${response.statusText}`);
            }

            // Create a blob from the response
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            // Create a temporary anchor element to trigger the download
            const a = document.createElement("a");
            a.href = url;
            a.download = `Question_Template_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(a);
            a.click();

            // Clean up
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            // Show success message
            setSnackbarMessage("Template exported successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Export template failed:", error);
            setSnackbarMessage(`Export template failed: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };


    const handleFileUpload = (event) => {
        setSelectedFile(event.target.files[0]);
        console.log("File selected:", event.target.files[0]); // Log after file selection
    };

    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: theme.palette.background.paper,
        // bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        borderRadius: "10px",
    };






    const filteredFolders = useMemo(() => {
        return folders.filter((folder) =>
            folder.name.toLowerCase().includes(folderSearch.toLowerCase())
        );
    }, [folders, folderSearch]);

    const paginatedFolders = useMemo(() => {
        const start = folderPage * folderRowsPerPage;
        return filteredFolders.slice(start, start + folderRowsPerPage);
    }, [filteredFolders, folderPage, folderRowsPerPage]);

    const [formErrors, setFormErrors] = useState({});
    const [selectedFolderFilter, setSelectedFolderFilter] = useState("all");

    const navigate = useNavigate();

    // Fetch data
    useEffect(() => {
        const token = getToken();
        if (!token || !isValidAdminToken(token)) {
            navigate("/");
        } else {
            fetchStudents(token).then((studentsData) => {
                fetchFolders(token, studentsData);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [navigate]);

    const fetchStudents = async (token) => {
        try {
            const response = await fetch(`${API_BASE_URL}/students/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.ok) {
                const data = await response.json();
                setStudents(data.students);
                return data.students; // Return the students data
            } else {
                console.error("Failed to fetch students");
                return [];
            }
        } catch (error) {
            console.error("Error fetching students:", error);
            return [];
        }
    };

    const fetchFolders = async (token, studentsData = []) => {
        setFoldersLoading(true); // Start loading
        try {
            const response = await fetch(`${API_BASE_URL}/folders/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const foldersData = await response.json();

                // Fetch quizzes count for each folder
                const foldersWithQuizzes = await Promise.all(
                    foldersData.map(async (folder) => {
                        const quizzesResponse = await fetch(
                            `${API_BASE_URL}/client-admin/folder/${folder.id}/quizzes/`,
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            }
                        );

                        const quizzesData = await quizzesResponse.json();
                        const quizzesCount = quizzesData.total || 0;

                        // Find all students assigned to this folder
                        const assignedStudents = studentsData.filter((student) =>
                            student.assigned_folders.some((f) => f.id === folder.id)
                        );

                        return {
                            ...folder,
                            quizzes_count: quizzesCount,
                            assigned_students: assignedStudents, // Store full student objects
                            assigned_students_count: assignedStudents.length,
                        };
                    })
                );

                setFolders(foldersWithQuizzes);
            } else {
                console.error("Failed to fetch courses");
            }
        } catch (error) {
            console.error("Error fetching courses:", error);
        } finally {
            setFoldersLoading(false); // Stop loading
        }
    };

    const handleExportFolder = async (folderId) => {
        try {
            const token = getToken();
            const response = await fetch(

                `${API_BASE_URL}/export/folders/excel/?folder_ids=${folderId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (!response.ok) {
                throw new Error(`Export failed: ${response.status} ${response.statusText}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Folder_${folderId}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            setSnackbarMessage("Course exported successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Export failed:", error);
            setSnackbarMessage(`Export failed: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };



    // Filter and pagination logic
    const filteredStudents = useMemo(() => {
        return students.filter((student) => {
            const matchesSearch =
                student.name.toLowerCase().includes(studentSearch.toLowerCase()) ||
                student.email.toLowerCase().includes(studentSearch.toLowerCase());
            const matchesFolder =
                selectedFolderFilter === "all" ||
                student.assigned_folders.some((folder) => folder.id === selectedFolderFilter);
            return matchesSearch && matchesFolder;
        });
    }, [students, studentSearch, selectedFolderFilter]);

    const paginatedStudents = useMemo(() => {
        const start = studentPage * studentRowsPerPage;
        return filteredStudents.slice(start, start + studentRowsPerPage);
    }, [filteredStudents, studentPage, studentRowsPerPage]);

    // Handlers
    const handleViewResult = (student) => {
        setSelectedStudent(student);
        setQuizPage(0);
        setExpandedFolder(null);
        fetchQuizResults(student.id);
    };

    const handleExportAllLoginDetails = async () => {
        try {
            const token = getToken();
            const response = await fetch(
                `${API_BASE_URL}/export-student-login-details/`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (!response.ok) {
                throw new Error(`Export failed: ${response.status} ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `All_Student_Login_Details_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setSnackbarMessage("All student login details exported successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Export failed:", error);
            setSnackbarMessage(`Export failed: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };


    const handleExportLoginDetails = async () => {
        try {
            const token = getToken();
            const response = await fetch(
                `${API_BASE_URL}/export-single-student-login-details/${loginDetails.student_id}/`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (!response.ok) {
                throw new Error(`Export failed: ${response.status} ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Login_Details_${loginDetails.student_name || "Student"}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setSnackbarMessage("Login details exported successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Export failed:", error);
            setSnackbarMessage(`Export failed: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };


    const handleExportQuizResult = async (studentId) => {
        try {
            const token = getToken();
            const response = await fetch(
                `${API_BASE_URL}/students/${studentId}/export-quiz-results/`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (!response.ok) {
                throw new Error(`Export failed: ${response.status} ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Quiz_Results_${selectedStudent?.name || "Student"}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setSnackbarMessage("Quiz results exported successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Export failed:", error);
            setSnackbarMessage(`Export failed: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };


    const handleSnackbarClose = () => setSnackbarOpen(false);
    const fetchQuizResults = async (studentId) => {
        try {
            const token = getToken();
            const response = await fetch(`${API_BASE_URL}/students/${studentId}/quiz-results/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.ok) {
                const data = await response.json();
                setQuizResults(data);
                setQuizModalOpen(true);
            } else {
                console.error("Failed to fetch quiz results");
            }
        } catch (error) {
            console.error("Error fetching quiz results:", error);
        }
    };

    const fetchLoginDetails = async (studentId) => {
        try {
            const token = getToken();
            const response = await fetch(
                `${API_BASE_URL}/quiz/admin/student-login-details/${studentId}/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.ok) {
                const data = await response.json();
                setLoginDetails(data);
                setLoginModalOpen(true);
            } else {
                console.error("Failed to fetch login details");
            }
        } catch (error) {
            console.error("Error fetching login details:", error);
        }
    };

    const handleDeleteStudent = async () => {
        try {
            const token = getToken();
            const response = await fetch(`${API_BASE_URL}/students/${studentToDelete.id}/`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.ok) {
                await fetchStudents(token);
                setDeleteDialogOpen(false);
            } else {
                console.error("Failed to delete student");
            }
        } catch (error) {
            console.error("Error deleting student:", error);
        }
    };

    const openDeleteDialog = (student) => {
        setStudentToDelete(student);
        setDeleteDialogOpen(true);
    };

    const closeDeleteDialog = () => {
        setDeleteDialogOpen(false);
    };

    const handleAssignFolder = (student) => {
        setSelectedStudent(student);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedFolders([]);
        setSelectedFolder(null);
    };

    const handleAssign = async () => {
        if (selectedFolders.length === 0) return;
        try {
            const token = getToken();
            const response = await fetch(`${API_BASE_URL}/folders/assign_to_student/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    student_id: selectedStudent.id,
                    folder_names: selectedFolders.map((f) => f.name),
                }),
            });
            if (response.ok) {
                await fetchStudents(token);
                handleCloseModal();
                setSelectedFolders([]);
                setSnackbarMessage("courses assigned successfully!");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
            } else {
                console.error("Failed to assign course");
                setSnackbarMessage("Failed to assign courses.");
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Error assigning course:", error);
            setSnackbarMessage(`Error: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };

    const handleImportFolder = async () => {
        console.log("Import clicked"); // Log at function start

        if (!selectedFile) {
            console.error("No file selected!"); // Log if no file
            return;
        }

        try {
            const token = getToken();
            if (!token) {
                console.error("No token found!"); // Log if no token
                return;
            }

            const formData = new FormData();
            formData.append("file", selectedFile);
            console.log("FormData prepared with file:", selectedFile);

            const response = await fetch(`${API_BASE_URL}/import/folders/excel/`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            console.log("API response status:", response.status);

            //         if (response.ok) {
            //             setSnackbarMessage("Success!");
            //             setSnackbarSeverity("success");
            //             setSnackbarOpen(true);
            //             setImportFolderModalOpen(false);
            //         } else {
            //             setSnackbarMessage("Import failed.");
            //             setSnackbarSeverity("error");
            //             setSnackbarOpen(true);
            //         }
            //     } catch (error) {
            //         console.error("Error:", error); // Log error caught in try/catch
            //         setSnackbarMessage("Error importing folders.");
            //         setSnackbarSeverity("error");
            //         setSnackbarOpen(true);
            //     }
            // };
            if (response.ok) {
                const data = await response.json();
                console.log("API response data:", data);

                // Store the import details and open the success dialog
                setImportDetails(data);
                setImportSuccessDialogOpen(true);
                setImportFolderModalOpen(false);
                setSelectedFile(null);

                // Optionally refresh the folders list
                // fetchFolders();
            } else {
                const errorData = await response.json().catch(() => ({}));
                const errorMessage = errorData.message || errorData.error || "Import failed.";

                setSnackbarMessage(errorMessage);
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Error:", error);
            setSnackbarMessage("Error importing courses. Please try again.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };


    const handleBulkRemoveFolder = (folder) => {
        setSelectedFolderForRemove(folder);
        setSelectedStudentsForRemove([]);
        setRemoveFolderModalOpen(true);
    };

    const handleCloseBulkRemoveModal = () => {
        setRemoveFolderModalOpen(false);
        setSelectedStudentsForRemove([]);
        setSelectedFolderForRemove(null);
    };

    const handleBulkRemoveFolderSubmit = async () => {
        if (selectedStudentsForRemove.length === 0) return;

        try {
            const token = getToken();
            const folderName = selectedFolderForRemove.name;

            // Loop through each student and remove the folder
            for (const student of selectedStudentsForRemove) {
                const response = await fetch(`${API_BASE_URL}/students/remove_folder/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        student_id: student.id, // Single student ID
                        folder_names: [folderName], // List of folder names (even if just one)
                    }),
                });

                if (!response.ok) {
                    console.error(`Failed to remove course from student ${student.id}`);
                }
            }

            // Refresh data after all removals
            const studentsData = await fetchStudents(token);
            await fetchFolders(token, studentsData);
            handleCloseBulkRemoveModal();
            setSnackbarMessage("Course removed from selected students successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);

        } catch (error) {
            console.error("Error removing course from students:", error);
            setSnackbarMessage(`Error: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };



    const handleRemoveFolder = (student) => {
        setSelectedStudent(student);
        setRemoveModalOpen(true);
    };

    const handleCloseRemoveModal = () => {
        setRemoveModalOpen(false);
        setSelectedFolders([]);
    };


    const handleRemove = async () => {
        if (selectedFolders.length === 0) return;
        try {
            const token = getToken();
            const response = await fetch(`${API_BASE_URL}/students/remove_folder/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    student_id: selectedStudent.id,
                    folder_names: selectedFolders.map((f) => f.name),
                }),
            });
            if (response.ok) {
                await fetchStudents(token);
                handleCloseRemoveModal();
                setSelectedFolders([]);
                setSnackbarMessage("courses removed successfully!");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);
            } else {
                console.error("Failed to remove courses");
                setSnackbarMessage("Failed to remove courses.");
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Error removing courses:", error);
            setSnackbarMessage(`Error: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
    };



    const handleStudentPageChange = (event, newPage) => {
        setStudentPage(newPage);
    };

    const handleStudentRowsPerPageChange = (event) => {
        setStudentRowsPerPage(parseInt(event.target.value, 10));
        setStudentPage(0);
    };

    const clearStudentSearch = () => {
        setStudentSearch("");
        setStudentPage(0);
    };

    const openEditModal = (student) => {
        setEditStudent(student);
        setFormData({
            student_name: student.name,
            student_email: student.email,
            password: "",
            confirmPassword: "",
        });
        setFormErrors({});
        setEditModalOpen(true);
    };

    const closeEditModal = () => {
        setEditModalOpen(false);
        setFormData({
            student_name: "",
            student_email: "",
            password: "",
            confirmPassword: "",
        });
        setFormErrors({});
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.student_name.trim()) errors.student_name = "Name is required";
        if (!formData.student_email.trim()) errors.student_email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.student_email))
            errors.student_email = "Invalid email format";
        if (formData.password && formData.password !== formData.confirmPassword)
            errors.confirmPassword = "Passwords do not match";
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleEditSubmit = async () => {
        if (!validateForm()) return;
        try {
            const token = getToken();
            const payload = {
                student_name: formData.student_name,
                student_email: formData.student_email,
                ...(formData.password && { password: formData.password }),
            };
            const response = await fetch(`${API_BASE_URL}/students/${editStudent.id}/update/`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                await fetchStudents(token);
                closeEditModal();
                setSnackbarMessage("Student Credentials updated successfully!")
                setSnackbarSeverity("success")
                setSnackbarOpen('true')
            } else {
                console.error("Failed to update student");
                setSnackbarMessage("Failed to update Student Credentials!")
                setSnackbarSeverity("error")
                setSnackbarOpen('true')
            }
        } catch (error) {
            console.error("Error updating student:", error);
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh"
                sx={{ background: theme.palette.background.default }}>

                <CircularProgress />

            </Box>
        );
    }
    const handleFolderPageChange = (event, newPage) => setFolderPage(newPage);
    const handleFolderRowsPerPageChange = (event) => {
        setFolderRowsPerPage(parseInt(event.target.value, 10));
        setFolderPage(0);
    };
    const handleAssignFolderToStudents = (folder) => {
        setSelectedFolderForAssign(folder);
        setAssignFolderModalOpen(true);
    };

    const handleCloseAssignFolderModal = () => {
        setAssignFolderModalOpen(false);
        setSelectedStudentsForFolder([]);
        setSelectedFolderForAssign(null);
    };

    const handleAssignFolderSubmit = async () => {
        if (selectedStudentsForFolder.length === 0) return;

        try {
            const token = getToken();
            const response = await fetch(`${API_BASE_URL}/folders/assign_to_multiple_students/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    folder_id: selectedFolderForAssign.id,
                    student_ids: selectedStudentsForFolder.map((s) => s.id),
                }),
            });

            if (response.ok) {
                const studentsData = await fetchStudents(token);
                await fetchFolders(token, studentsData); // Pass students data
                handleCloseAssignFolderModal();
                setSelectedFolders([]);
                setSnackbarMessage("Courses assigned successfully!");
                setSnackbarSeverity("success");
                setSnackbarOpen(true);


            } else {
                console.error("Failed to assign course to students");
                setSnackbarMessage("Failed to assign courses to students");
                setSnackbarSeverity("error");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Error assigning folder to students:", error);
            setSnackbarMessage(`Error: ${error.message}`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true)
        }
    };



    return (
        <Box
            sx={{
                p: { xs: 2, sm: 3, md: 4 },
                // maxWidth: 1200,
                // mx: "auto",
                minHeight: "100vh",
                background: theme.palette.background.default,
                //   background: "linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%)",
                // borderRadius: "24px",
                // boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 4,
                }}
            >
                <div>
                    <Typography
                        variant="h3"
                        gutterBottom
                        sx={{
                            fontWeight: "800",
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                            // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text",
                        }}
                    >
                        Control Panel
                    </Typography>
                </div>
                <Box sx={{ display: "flex", gap: 2 }}>
                    <Button
                        variant={activeTab === "student" ? "contained" : "outlined"}
                        onClick={() => setActiveTab("student")}
                        sx={{
                            borderRadius: "12px",
                            padding: "10px 24px",
                            fontWeight: "600",
                            textTransform: "none",
                            background:
                                activeTab === "student"
                                    ? theme.palette.mode === 'light'
                                        ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                        : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)"
                                    : "transparent",
                            color: activeTab === "student" ? "white" : theme.palette.primary.main,
                            "&:hover": {
                                background:
                                    activeTab === "student"
                                        ? theme.palette.mode === 'light'
                                            ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                            : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)"
                                        : theme.palette.mode === 'light' ? "rgba(102, 126, 234, 0.1)" : "rgba(132, 144, 255, 0.1)",

                            },
                        }}
                    >
                        Student Management
                    </Button>
                    <Button
                        variant={activeTab === "folder" ? "contained" : "outlined"}
                        onClick={() => setActiveTab("folder")}
                        sx={{
                            borderRadius: "12px",
                            padding: "10px 24px",
                            fontWeight: "600",
                            textTransform: "none",
                            background:
                                activeTab === "folder"
                                    ? theme.palette.mode === 'light'
                                        ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                        : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)"
                                    : "transparent",
                            color: activeTab === "folder" ? "white" : theme.palette.primary.main,
                            "&:hover": {
                                background:
                                    activeTab === "folder"
                                        ? theme.palette.mode === 'light'
                                            ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                            : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)"
                                        : theme.palette.mode === 'light' ? "rgba(102, 126, 234, 0.1)" : "rgba(132, 144, 255, 0.1)",
                            },
                        }}
                    >
                        Course Management
                    </Button>
                    <Tooltip title="User Guide" arrow>
                        <IconButton
                            onClick={() => setInfoModalOpen(true)}
                            sx={{
                                bgcolor: theme.palette.mode === 'light' ? "rgba(102, 126, 234, 0.1)" : "rgba(132, 144, 255, 0.1)",
                                "&:hover": { bgcolor: theme.palette.mode === 'light' ? "rgba(102, 126, 234, 0.2)" : "rgba(132, 144, 255, 0.2)" },
                                p: 1.5,
                            }}
                        >
                            <InfoOutlinedIcon sx={{ color: "#667eea" }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            {/* Merged Table */}
            {activeTab === "student" && (
                <Paper
                    sx={{
                        p: 4,
                        mb: 4,
                        borderRadius: "16px",
                        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
                        border: `1px solid ${theme.palette.divider}`,
                        transition: "all 0.3s ease",
                        "&:hover": {
                            boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
                        },
                        backgroundColor: theme.palette.background.paper,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2,
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{ color: theme.palette.text.primary, fontWeight: "700" }}
                        >
                            Student Management
                        </Typography>
                        <Button
                            variant="outlined"
                            onClick={handleExportAllLoginDetails}
                            startIcon={
                                <i
                                    className="bi bi-download"
                                    style={{ fontSize: "1.2rem" }}
                                ></i>
                            }
                            sx={{
                                color: "#667eea",
                                borderColor: "#667eea",
                                fontWeight: "600",
                                borderRadius: "12px",
                                textTransform: "none",
                                "&:hover": {
                                    background: theme.palette.mode === 'light' ? "rgba(102, 126, 234, 0.08)" : "rgba(132, 144, 255, 0.08)",
                                    borderColor: "#667eea",
                                },
                            }}
                        >
                            Export Login Details
                        </Button>
                    </Box>

                    <Divider sx={{ my: 2, borderColor: theme.palette.divider }} />

                    {/* Search and Filter */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            mb: 2,
                            gap: 2,
                        }}
                    >
                        <TextField
                            placeholder="Search Students..."
                            value={studentSearch}
                            onChange={(e) => {
                                setStudentSearch(e.target.value);
                                setStudentPage(0);
                            }}
                            variant="outlined"
                            size="small"
                            sx={{ width: 300 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: studentSearch && (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={clearStudentSearch}>
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            select
                            label="Filter by Courses"
                            variant="outlined"
                            size="small"
                            value={selectedFolderFilter}
                            onChange={(e) => {
                                setSelectedFolderFilter(e.target.value);
                                setStudentPage(0);
                            }}
                            sx={{ minWidth: 200 }}

                            SelectProps={{
                                MenuProps: {
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 300,
                                            "&::-webkit-scrollbar": {
                                                width: "10px",
                                            },
                                            "&::-webkit-scrollbar-track": {
                                                background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                                borderRadius: "6px",
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                                background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                                borderRadius: "6px",
                                                border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                            },
                                            "&::-webkit-scrollbar-thumb:hover": {
                                                background: '#64748b',
                                            },
                                            scrollbarWidth: "thin",
                                            scrollbarColor: theme.palette.mode === 'dark'
                                                ? '#475569 #2d3748'
                                                : '#94a3b8 #f1f5f9',
                                        },
                                    },
                                },
                            }}

                        >
                            <MenuItem value="all">All Courses</MenuItem>
                            {folders.map((folder) => (
                                <MenuItem key={folder.id} value={folder.id}>
                                    {folder.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Box>

                    {/* Table */}
                    <TableContainer component={Paper} sx={{ borderRadius: "12px", backgroundColor: theme.palette.background.paper }}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ bgcolor: theme.palette.mode === 'light' ? "#f8f9ff" : "rgba(55, 65, 81, 0.5)" }}>
                                    <TableCell sx={{ fontWeight: "600", width: "60px", color: theme.palette.text.primary }}>S.No</TableCell>
                                    <TableCell sx={{ fontWeight: "600", minWidth: "180px", color: theme.palette.text.primary }}>Student Name</TableCell>
                                    <TableCell sx={{ fontWeight: "600", minWidth: "200px", maxWidth: "250px", color: theme.palette.text.primary }}>Email</TableCell>
                                    <TableCell sx={{ fontWeight: "600", minWidth: "200px", color: theme.palette.text.primary }}>Assigned Courses</TableCell>
                                    <TableCell sx={{ fontWeight: "600", width: "120px", textAlign: "center", color: theme.palette.text.primary }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedStudents.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center" sx={{ color: theme.palette.text.secondary }}>
                                            {studentSearch || selectedFolderFilter !== "all"
                                                ? "No students found matching your criteria"
                                                : "No students available"}
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    paginatedStudents.map((student, index) => (
                                        <TableRow
                                            key={student.id}
                                            sx={{ "&:hover": { bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.3)" } }}
                                        >
                                            <TableCell sx={{ color: theme.palette.text.primary }}>
                                                {studentPage * studentRowsPerPage + index + 1}
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: "500", color: theme.palette.text.primary }}>{student.name}</TableCell>
                                            <TableCell>
                                                <Tooltip title={student.email} arrow placement="top">
                                                    <Box
                                                        sx={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            maxWidth: "250px",
                                                            color: theme.palette.text.secondary,
                                                        }}
                                                    >
                                                        {student.email}
                                                    </Box>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell sx={{ color: theme.palette.text.primary }}>
                                                {student.assigned_folders.length > 0 ? (
                                                    <Tooltip
                                                        title={
                                                            <Box sx={{ p: 1 }}>
                                                                {student.assigned_folders.map((folder) => (
                                                                    <Typography
                                                                        key={folder.id}
                                                                        variant="body2"
                                                                        sx={{ mb: 0.5, color: theme.palette.text.primary }}
                                                                    >
                                                                        • {folder.name}
                                                                    </Typography>
                                                                ))}
                                                            </Box>
                                                        }
                                                        arrow
                                                        placement="top"
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                gap: 0.5,
                                                                flexWrap: "wrap",
                                                                maxWidth: "280px",
                                                            }}
                                                        >
                                                            {student.assigned_folders
                                                                .slice(0, 2)
                                                                .map((folder) => (
                                                                    <Chip
                                                                        key={folder.id}
                                                                        label={folder.name}
                                                                        size="small"
                                                                        color="primary"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            maxWidth: "130px",
                                                                            "& .MuiChip-label": {
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                            },
                                                                        }}
                                                                    />
                                                                ))}
                                                            {student.assigned_folders.length > 2 && (
                                                                <Chip
                                                                    label={`+${student.assigned_folders.length - 2
                                                                        }`}
                                                                    size="small"
                                                                    color="primary"
                                                                    variant="filled"
                                                                />
                                                            )}
                                                        </Box>
                                                    </Tooltip>
                                                ) : (
                                                    <span
                                                        style={{ color: theme.palette.text.secondary, fontSize: "0.875rem" }}
                                                    >
                                                        No courses assigned
                                                    </span>
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                        setAnchorEl(e.currentTarget);
                                                        setSelectedStudent(student);
                                                    }}
                                                    sx={{
                                                        bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.5)",
                                                        "&:hover": { bgcolor: theme.palette.mode === 'light' ? "#e0e0e0" : "rgba(55, 65, 81, 0.7)" },
                                                    }}
                                                >
                                                    <MoreVertIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={filteredStudents.length}
                            rowsPerPage={studentRowsPerPage}
                            page={studentPage}
                            onPageChange={handleStudentPageChange}
                            onRowsPerPageChange={handleStudentRowsPerPageChange}
                            sx={{
                                borderTop: `1px solid ${theme.palette.divider}`,
                                bgcolor: theme.palette.background.paper,
                            }}
                        />
                    </TableContainer>
                    {/* Actions Menu */}
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => {
                            setAnchorEl(null);
                            setSelectedStudent(null);
                        }}
                        PaperProps={{
                            sx: {
                                borderRadius: "8px",
                                minWidth: "200px",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                                bgcolor: theme.palette.background.paper,
                            },
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                handleViewResult(selectedStudent);
                                setAnchorEl(null);
                            }}
                            sx={{ py: 1.5, gap: 1.5 }}
                        >
                            <VisibilityIcon fontSize="small" color="primary" />
                            <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>View Result</Typography>
                        </MenuItem>
                        <MenuItem
                            onClick={async () => {
                                await handleExportQuizResult(selectedStudent.id);
                                setAnchorEl(null);
                            }}
                            sx={{ py: 1.5, gap: 1.5 }}
                        >
                            <i
                                className="bi bi-download"
                                style={{ fontSize: "1.2rem", color: "#667eea" }}
                            ></i>
                            <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>Export Results</Typography>
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                fetchLoginDetails(selectedStudent.id);
                                setAnchorEl(null);
                            }}
                            sx={{ py: 1.5, gap: 1.5 }}
                        >
                            <LoginIcon fontSize="small" color="secondary" />
                            <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>Login Details</Typography>
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                            onClick={() => {
                                handleAssignFolder(selectedStudent);
                                setAnchorEl(null);
                            }}
                            sx={{ py: 1.5, gap: 1.5 }}
                        >
                            <AssignmentIcon fontSize="small" sx={{ color: "#1976d2" }} />
                            <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>Assign Course</Typography>
                        </MenuItem>
                        {selectedStudent?.assigned_folders.length > 0 && (
                            <MenuItem
                                onClick={() => {
                                    handleRemoveFolder(selectedStudent);
                                    setAnchorEl(null);
                                }}
                                sx={{ py: 1.5, gap: 1.5 }}
                            >
                                <RemoveCircleIcon fontSize="small" color="error" />
                                <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>Remove Course</Typography>
                            </MenuItem>
                        )}
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                            onClick={() => {
                                openEditModal(selectedStudent);
                                setAnchorEl(null);
                            }}
                            sx={{ py: 1.5, gap: 1.5 }}
                        >
                            <EditIcon fontSize="small" sx={{ color: "#ed6c02" }} />
                            <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>Edit Student</Typography>
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                openDeleteDialog(selectedStudent);
                                setAnchorEl(null);
                            }}
                            sx={{ py: 1.5, gap: 1.5, color: "#d32f2f" }}
                        >
                            <DeleteIcon fontSize="small" color="error" />
                            <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>Delete Student</Typography>
                        </MenuItem>
                    </Menu>
                </Paper>
            )}
            {activeTab === "folder" && (
                <Box>
                    {activeTab === "folder" && (
                        <Paper
                            sx={{
                                p: 4,
                                mb: 4,
                                borderRadius: "16px",
                                boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
                                border: `1px solid ${theme.palette.divider}`,
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
                                },
                                backgroundColor: theme.palette.background.paper,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 2,
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{ color: theme.palette.text.primary, fontWeight: "700" }}
                                >
                                    Courses Management
                                </Typography>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={
                                            <i
                                                className="bi bi-file-earmark-text"
                                                style={{ fontSize: "1.2rem" }}
                                            ></i>
                                        }
                                        onClick={handleExportTemplate}
                                        sx={{
                                            color: "#667eea",
                                            borderColor: "#667eea",
                                            fontWeight: "600",
                                            borderRadius: "12px",
                                            textTransform: "none",
                                            "&:hover": {
                                                background: "rgba(102, 126, 234, 0.08)",
                                                borderColor: "#667eea",
                                            },
                                        }}
                                    >
                                        Export Template
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={
                                            <i
                                                className="bi bi-download"
                                                style={{ fontSize: "1.2rem" }}
                                            ></i>
                                        }
                                        onClick={() => setExportQaModalOpen(true)}
                                        sx={{
                                            color: "#667eea",
                                            borderColor: "#667eea",
                                            fontWeight: "600",
                                            borderRadius: "12px",
                                            textTransform: "none",
                                            "&:hover": {
                                                background: "rgba(102, 126, 234, 0.08)",
                                                borderColor: "#667eea",
                                            },
                                        }}
                                    >
                                        Export Course
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        startIcon={
                                            <i
                                                className="bi bi-upload"
                                                style={{ fontSize: "1.2rem" }}
                                            ></i>
                                        }
                                        onClick={() => setImportFolderModalOpen(true)}
                                        sx={{
                                            color: "#667eea",
                                            borderColor: "#667eea",
                                            fontWeight: "600",
                                            borderRadius: "12px",
                                            textTransform: "none",
                                            "&:hover": {
                                                background: "rgba(102, 126, 234, 0.08)",
                                                borderColor: "#667eea",
                                            },
                                        }}
                                    >
                                        Import Course
                                    </Button>
                                    {/* Import Success Dialog */}
                                    <Dialog
                                        open={importSuccessDialogOpen}
                                        onClose={() => setImportSuccessDialogOpen(false)}
                                        PaperProps={{
                                            style: {
                                                borderRadius: "20px",
                                                padding: "10px 0",
                                                minWidth: "450px",
                                                maxWidth: "600px",
                                                backgroundColor: theme.palette.background.paper,
                                            }
                                        }}
                                    >
                                        <DialogTitle
                                            style={{
                                                fontSize: "1.8rem",
                                                fontWeight: "800",
                                                background: theme.palette.mode === 'light'
                                                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                    : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text",
                                                paddingBottom: "10px",
                                                borderBottom: `2px solid ${theme.palette.divider}`,
                                            }}
                                        >
                                            <i className="bi bi-check-circle-fill" style={{ marginRight: "10px" }}></i>
                                            Import Successful
                                        </DialogTitle>
                                        <DialogContent style={{ paddingTop: "24px" }}>
                                            {importDetails && (
                                                <Box>
                                                    <Typography variant="h6" sx={{ fontWeight: "600", mb: 2, color: theme.palette.primary.main }}>
                                                        Courses Created:
                                                    </Typography>
                                                    {importDetails.created_folders?.map((folder, index) => (
                                                        <Box
                                                            key={index}
                                                            sx={{
                                                                // p: 2,
                                                                mb: 2,
                                                                borderRadius: "12px",
                                                                // backgroundColor: theme.palette.background.paper,
                                                                //    border: `1px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                                            }}
                                                        >
                                                            <Typography variant="body1" sx={{ fontWeight: "600", color: theme.palette.text.primary }}>
                                                                {folder.original_folder_name === folder.new_folder_name ? (
                                                                    <>Folder: <span style={{ color: "#667eea" }}>{folder.new_folder_name}</span></>
                                                                ) : (
                                                                    <>
                                                                        Original Folder Name: <span style={{ color: theme.palette.text.secondary }}>{folder.original_folder_name}</span>
                                                                        <br />
                                                                        New Folder Name: <span style={{ color: "#667eea" }}>{folder.new_folder_name}</span>
                                                                    </>
                                                                )}
                                                            </Typography>
                                                        </Box>
                                                    ))}

                                                    {importDetails.created_questions && importDetails.created_questions.length > 0 && (
                                                        <>
                                                            <Divider sx={{ my: 2 }} />
                                                            <Typography variant="h6" sx={{ fontWeight: "600", mb: 1, color: theme.palette.primary.main }}>
                                                                Questions Imported:
                                                            </Typography>
                                                            <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
                                                                Total: <strong>{importDetails.created_questions.length}</strong> questions
                                                            </Typography>
                                                            <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                                {Object.entries(
                                                                    importDetails.created_questions.reduce((acc, q) => {
                                                                        acc[q.type] = (acc[q.type] || 0) + 1;
                                                                        return acc;
                                                                    }, {})
                                                                ).map(([type, count]) => (
                                                                    <Chip
                                                                        key={type}
                                                                        label={`${type}: ${count}`}
                                                                        size="small"
                                                                        sx={{
                                                                            fontWeight: "600",
                                                                            backgroundColor: theme.palette.mode === 'light' ? "#e0f2fe" : "rgba(56, 189, 248, 0.1)",
                                                                            color: theme.palette.text.secondary,
                                                                        }}
                                                                    />
                                                                ))}
                                                            </Box>
                                                        </>
                                                    )}
                                                </Box>
                                            )}
                                        </DialogContent>
                                        <DialogActions sx={{ p: 2 }}>
                                            <Button
                                                onClick={() => {setImportSuccessDialogOpen(false)
                                                     window.location.reload();}
                                                }
                                                variant="contained"
                                                sx={{
                                                    background: theme.palette.mode === 'light'
                                                        ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                        : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                                    color: "white",
                                                    padding: "10px 28px",
                                                    fontSize: "1rem",
                                                    fontWeight: "700",
                                                    borderRadius: "10px",
                                                    textTransform: "none",
                                                    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                                                    "&:hover": {
                                                        background: theme.palette.mode === 'light'
                                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                                        boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                                                    },
                                                }}
                                            >
                                                Close
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                    <Dialog
                                        open={importFolderModalOpen}
                                        onClose={() => {
                                            setImportFolderModalOpen(false);
                                            setSelectedFile(null);
                                        }}
                                        PaperProps={{
                                            style: {
                                                borderRadius: "20px",
                                                padding: "10px 0",
                                                minWidth: "400px",
                                                maxWidth: "50vw",
                                                backgroundColor: theme.palette.background.paper,
                                                "&::-webkit-scrollbar": {
                                                    width: "10px",
                                                    height: "10px",
                                                },
                                                "&::-webkit-scrollbar-track": {
                                                    background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                                    borderRadius: "6px",
                                                },
                                                "&::-webkit-scrollbar-thumb": {
                                                    background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                                    borderRadius: "6px",
                                                    border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                                },
                                                "&::-webkit-scrollbar-thumb:hover": {
                                                    background: theme.palette.mode === 'dark' ? '#64748b' : '#64748b',
                                                },
                                                // Custom scrollbar for Firefox
                                                scrollbarWidth: "thin",
                                                scrollbarColor: theme.palette.mode === 'dark' ? '#475569 #2d3748' : '#94a3b8 #f1f5f9',
                                            }
                                        }
                                        }

                                    >
                                        <DialogTitle
                                            style={{
                                                fontSize: "1.8rem",
                                                fontWeight: "800",
                                                background: theme.palette.mode === 'light'
                                                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                    : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text",
                                                paddingBottom: "10px",
                                                borderBottom: `2px solid ${theme.palette.divider}`,
                                            }}
                                        >
                                            <i className="bi bi-upload" style={{ marginRight: "10px" }}></i>
                                            Import courses from Excel
                                        </DialogTitle>
                                        <DialogContent style={{ paddingTop: "24px" }}>
                                            <DialogContentText
                                                style={{
                                                    marginBottom: "24px",
                                                    color: theme.palette.text.secondary,
                                                    fontSize: "1.05rem",
                                                    lineHeight: 1.6,
                                                }}
                                            >
                                                <Typography variant="subtitle1" sx={{ fontWeight: "600", mb: 1, color: theme.palette.text.primary }}>
                                                    <IconButton> <WarningIcon sx={{ color: theme.palette.warning.main }} /> </IconButton>Important Instructions:
                                                </Typography>
                                                <Typography variant="body2" sx={{ mb: 1.5, color: theme.palette.text.secondary }}>
                                                    <strong>Export First:</strong> Before importing, you must first export the course you want to import. Use the "Export course" option to download the course as an .xlsx file.
                                                </Typography>
                                                <Typography variant="body2" sx={{ mb: 1.5, color: theme.palette.text.secondary }}>
                                                    <strong>File Requirements:</strong>
                                                    <ul style={{ marginTop: 8, marginBottom: 8, paddingLeft: 20 }}>
                                                        <li>The file must be in .xlsx format.</li>
                                                        {/* <li>The sheet name in the Excel file must be "Exported Folders".</li> */}
                                                        <li>The file must include the following required headers in the first row:</li>
                                                        <ul style={{ paddingLeft: 20 }}>
                                                            <li>Folder Name</li>
                                                            <li>Question ID</li>
                                                            <li>Question Type</li>
                                                            <li>Statement</li>
                                                            <li>Answer</li>
                                                            <li>Is Correct</li>
                                                            <li>Explanation</li>
                                                        </ul>
                                                    </ul>
                                                </Typography>
                                                <Typography variant="body2" sx={{ mb: 1.5, color: theme.palette.text.secondary }}>
                                                    <strong>How to Import:</strong>
                                                    <ul style={{ marginTop: 8, marginBottom: 8, paddingLeft: 20 }}>
                                                        <li>Ensure the file follows the structure described above.</li>
                                                        <li>Upload the .xlsx file using the "Choose Excel File" button.</li>
                                                        <li>Click "Import" to create a new course with all the questions from the imported file.</li>
                                                    </ul>
                                                </Typography>
                                                <Typography variant="body2" sx={{ mb: 1.5, color: theme.palette.text.secondary }}>
                                                    <strong>Note:</strong>
                                                    <ul style={{ marginTop: 8, marginBottom: 8, paddingLeft: 20 }}>
                                                        <li>The imported file will create a new course with the same name as specified in the "Course Name" column.</li>
                                                        <li>All questions in the file will be added to this new course.</li>
                                                    </ul>
                                                </Typography>
                                                Upload an Excel file to import courses.
                                            </DialogContentText>
                                            <Box sx={{ mb: 2 }}>
                                                <input
                                                    type="file"
                                                    accept=".xlsx"
                                                    onChange={handleFileUpload}
                                                    id="import-excel-file"
                                                    style={{ display: "none" }}
                                                />
                                                <label htmlFor="import-excel-file">
                                                    <Button
                                                        variant="outlined"
                                                        component="span"
                                                        fullWidth
                                                        sx={{
                                                            borderRadius: "12px",
                                                            padding: "12px",
                                                            fontWeight: "600",
                                                            textTransform: "none",
                                                            border: "2px dashed #667eea",
                                                            color: "#667eea",
                                                            "&:hover": {
                                                                border: "2px dashed #667eea",
                                                                background: theme.palette.mode === 'light' ? "rgba(102, 126, 234, 0.08)" : "rgba(132, 144, 255, 0.08)",
                                                            },
                                                        }}
                                                    >
                                                        {selectedFile ? selectedFile.name : "Choose Excel File"}
                                                    </Button>
                                                </label>
                                            </Box>
                                        </DialogContent>
                                        <DialogActions sx={{ p: 2 }}>
                                            <Button
                                                onClick={() => {
                                                    setImportFolderModalOpen(false);
                                                    setSelectedFile(null);
                                                }}
                                                sx={{
                                                    color: theme.palette.text.secondary,
                                                    padding: "10px 24px",
                                                    fontSize: "1rem",
                                                    fontWeight: "600",
                                                    borderRadius: "10px",
                                                    textTransform: "none",
                                                    "&:hover": {
                                                        background: theme.palette.mode === 'light' ? "#f3f4f6" : "rgba(55, 65, 81, 0.5)",
                                                    },
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                onClick={handleImportFolder}
                                                disabled={!selectedFile}
                                                variant="contained"
                                                sx={{
                                                    background: theme.palette.mode === 'light'
                                                        ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                        : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                                    color: "white",
                                                    padding: "10px 28px",
                                                    fontSize: "1rem",
                                                    fontWeight: "700",
                                                    borderRadius: "10px",
                                                    textTransform: "none",
                                                    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                                                    "&:hover": {
                                                        background: theme.palette.mode === 'light'
                                                            ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                                            : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)",
                                                        boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
                                                    },
                                                    "&.Mui-disabled": {
                                                        background: theme.palette.mode === 'light' ? "#d1d5db" : "rgba(209, 213, 219, 0.5)",
                                                        color: "white",
                                                        opacity: 0.6,
                                                    },
                                                }}
                                            >
                                                <i className="bi bi-check-circle" style={{ marginRight: "8px" }}></i>
                                                Import
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </Box>
                            </Box>
                            <Divider sx={{ my: 2, borderColor: theme.palette.divider }} />
                            {/* Search and Export Dropdown */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    mb: 2,
                                    gap: 2,
                                }}
                            >
                                <TextField
                                    placeholder="Search courses..."
                                    value={folderSearch}
                                    onChange={(e) => {
                                        setFolderSearch(e.target.value);
                                        setFolderPage(0);
                                    }}
                                    variant="outlined"
                                    size="small"
                                    sx={{ width: 300 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                        endAdornment: folderSearch && (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => setFolderSearch("")}
                                                >
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {/* Export Menu */}
                                <Menu
                                    anchorEl={exportAnchorEl}
                                    open={Boolean(exportAnchorEl)}
                                    onClose={() => setExportAnchorEl(null)}
                                    PaperProps={{
                                        sx: {
                                            borderRadius: "8px",
                                            minWidth: "200px",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                                            bgcolor: theme.palette.background.paper,
                                        },
                                    }}
                                >
                                    {folders.map((folder) => (
                                        <MenuItem
                                            key={folder.id}
                                            onClick={async () => {
                                                await handleExportFolder(folder.id);
                                                setExportAnchorEl(null);
                                            }}
                                            sx={{ py: 1.5, gap: 1.5 }}
                                        >
                                            <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>{folder.name}</Typography>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Box>
                            {/* Table or Loading Circle */}
                            {foldersLoading ? (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    py={4}
                                >
                                    <CircularProgress />
                                </Box>
                            ) : (
                                <TableContainer
                                    component={Paper}
                                    sx={{ borderRadius: "12px", backgroundColor: theme.palette.background.paper }}
                                >
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: theme.palette.mode === 'light' ? "#f8f9ff" : "rgba(55, 65, 81, 0.5)" }}>
                                                <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>S.No</TableCell>
                                                <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Course Name</TableCell>
                                                <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>No. of Quizzes</TableCell>
                                                <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Assigned to Students</TableCell>
                                                <TableCell sx={{ fontWeight: "600", textAlign: "center", color: theme.palette.text.primary }}>Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {paginatedFolders.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: theme.palette.text.secondary }}>
                                                        {folderSearch
                                                            ? "No courses found matching your criteria"
                                                            : "No courses available"}
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                paginatedFolders.map((folder, index) => (
                                                    <TableRow
                                                        key={folder.id}
                                                        sx={{ "&:hover": { bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.3)" } }}
                                                    >
                                                        <TableCell sx={{ color: theme.palette.text.primary }}>
                                                            {folderPage * folderRowsPerPage + index + 1}
                                                        </TableCell>
                                                        <TableCell sx={{ color: theme.palette.text.primary }}>{folder.name}</TableCell>
                                                        <TableCell sx={{ color: theme.palette.text.primary }}>{folder.quizzes_count || 0}</TableCell>
                                                        <TableCell sx={{ color: theme.palette.text.primary }}>
                                                            {folder.assigned_students &&
                                                                folder.assigned_students.length > 0 ? (
                                                                <Tooltip
                                                                    title={
                                                                        <Box sx={{ p: 1 }}>
                                                                            {folder.assigned_students.map(
                                                                                (student) => (
                                                                                    <Typography
                                                                                        key={student.id}
                                                                                        variant="body2"
                                                                                        sx={{ mb: 0.5, color: theme.palette.text.primary }}
                                                                                    >
                                                                                        • {student.name}
                                                                                    </Typography>
                                                                                )
                                                                            )}
                                                                        </Box>
                                                                    }
                                                                    arrow
                                                                    placement="top"
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            gap: 0.5,
                                                                            flexWrap: "wrap",
                                                                            maxWidth: "200px",
                                                                        }}
                                                                    >
                                                                        {folder.assigned_students
                                                                            .slice(0, 2)
                                                                            .map((student) => (
                                                                                <Chip
                                                                                    key={student.id}
                                                                                    label={student.name}
                                                                                    size="small"
                                                                                    color="primary"
                                                                                    variant="outlined"
                                                                                />
                                                                            ))}
                                                                        {folder.assigned_students.length > 2 && (
                                                                            <Chip
                                                                                label={`+${folder.assigned_students.length - 2
                                                                                    } more`}
                                                                                size="small"
                                                                                color="primary"
                                                                                variant="filled"
                                                                            />
                                                                        )}
                                                                    </Box>
                                                                </Tooltip>
                                                            ) : (
                                                                <span style={{ color: theme.palette.text.secondary }}>
                                                                    No students assigned
                                                                </span>
                                                            )}
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: "center" }}>
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                                size="small"
                                                                onClick={() =>
                                                                    handleAssignFolderToStudents(folder)
                                                                }
                                                                sx={{ mr: 1 }}
                                                            >
                                                                Bulk Assign
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="error"
                                                                size="small"
                                                                onClick={() => handleBulkRemoveFolder(folder)}
                                                            >
                                                                Bulk Remove
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                        component="div"
                                        count={filteredFolders.length}
                                        rowsPerPage={folderRowsPerPage}
                                        page={folderPage}
                                        onPageChange={handleFolderPageChange}
                                        onRowsPerPageChange={handleFolderRowsPerPageChange}
                                        sx={{
                                            borderTop: `1px solid ${theme.palette.divider}`,
                                            bgcolor: theme.palette.background.paper,
                                        }}
                                    />
                                </TableContainer>
                            )}
                        </Paper>
                    )}
                </Box>
            )}
            {/* Quiz Results Modal */}
            <Modal open={quizModalOpen} onClose={() => setQuizModalOpen(false)}>
                <Box
                    sx={{
                        p: 0,
                        bgcolor: theme.palette.background.paper,
                        mx: "auto",
                        mt: "3%",
                        mb: "3%",
                        width: "90%",
                        maxWidth: 900,
                        maxHeight: "90vh",
                        borderRadius: "20px",
                        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",

                    }}
                >
                    <Box
                        sx={{
                            p: 3,
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                                Quiz Results for {selectedStudent?.name} (
                                {selectedStudent?.email})
                            </Typography>
                            {quizResults && (
                                <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
                                    Client Code: {quizResults.client_code}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    <Box
                        // sx={{ p: 3, overflowY: "auto", flex: 1 }}>

                        sx={{
                            p: 3,
                            flex: 1,
                            overflowY: "auto",
                            bgcolor: theme.palette.background.default,
                            color: theme.palette.text.primary,

                            // SCROLLBAR — Webkit browsers
                            "&::-webkit-scrollbar": {
                                width: "10px",
                                height: "10px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                borderRadius: "6px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                borderRadius: "6px",
                                border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                background: theme.palette.mode === 'dark' ? '#64748b' : '#64748b',
                            },
                            // Custom scrollbar for Firefox
                            scrollbarWidth: "thin",
                            scrollbarColor: theme.palette.mode === 'dark' ? '#475569 #2d3748' : '#94a3b8 #f1f5f9',
                        }}
                    >


                        {quizResults ? (
                            <Box>
                                {Object.entries(
                                    quizResults.quiz_history.reduce((acc, quiz) => {
                                        if (!acc[quiz.folder_name]) acc[quiz.folder_name] = [];
                                        acc[quiz.folder_name].push(quiz);
                                        return acc;
                                    }, {})
                                ).map(([folderName, quizzes]) => (
                                    <Accordion
                                        key={folderName}
                                        expanded={expandedFolder === folderName}
                                        onChange={() =>
                                            setExpandedFolder(
                                                expandedFolder === folderName ? null : folderName
                                            )
                                        }
                                        sx={{
                                            boxShadow: "none",
                                            border: `1px solid ${theme.palette.divider}`,
                                            mb: 1,
                                            borderRadius: "8px",
                                        }}
                                    >
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography sx={{ fontWeight: "600", color: theme.palette.text.primary }}>
                                                {folderName}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <TableContainer
                                                component={Paper}
                                                sx={{ boxShadow: "none", borderRadius: "8px", backgroundColor: theme.palette.background.paper }}
                                            >
                                                <Table>
                                                    <TableHead>
                                                        <TableRow sx={{ bgcolor: theme.palette.mode === 'light' ? "#f8f9ff" : "rgba(55, 65, 81, 0.5)" }}>
                                                            <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Quiz Name</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Attempt</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Score (%)</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Result</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {quizzes
                                                            .flatMap((quiz) =>
                                                                quiz.attempts
                                                                    .sort(
                                                                        (a, b) =>
                                                                            new Date(b.ended_at) -
                                                                            new Date(a.ended_at)
                                                                    )
                                                                    .map((attempt) => ({
                                                                        ...attempt,
                                                                        quiz_name: quiz.quiz_name,
                                                                    }))
                                                            )
                                                            .slice(
                                                                quizPage * quizRowsPerPage,
                                                                quizPage * quizRowsPerPage + quizRowsPerPage
                                                            )
                                                            .map((attempt, index) => (
                                                                <TableRow
                                                                    key={index}
                                                                    sx={{ "&:hover": { bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.3)" } }}
                                                                >
                                                                    <TableCell sx={{ color: theme.palette.text.primary }}>{attempt.quiz_name}</TableCell>
                                                                    <TableCell sx={{ color: theme.palette.text.primary }}>{attempt.attempt_number}</TableCell>
                                                                    <TableCell sx={{ color: theme.palette.text.primary }}>{attempt.score_percentage.toFixed(2)}%</TableCell>
                                                                    <TableCell>
                                                                        <Chip
                                                                            label={attempt.result}
                                                                            size="small"
                                                                            sx={{
                                                                                bgcolor:
                                                                                    attempt.result === "Pass"
                                                                                        ? "#4caf50"
                                                                                        : "#f44336",
                                                                                color: "white",
                                                                                fontWeight: "bold",
                                                                                borderRadius: "8px",
                                                                            }}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                    </TableBody>
                                                </Table>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    component="div"
                                                    count={
                                                        quizzes.flatMap((quiz) => quiz.attempts).length
                                                    }
                                                    rowsPerPage={quizRowsPerPage}
                                                    page={quizPage}
                                                    onPageChange={(event, newPage) =>
                                                        setQuizPage(newPage)
                                                    }
                                                    onRowsPerPageChange={(event) => {
                                                        setQuizRowsPerPage(
                                                            parseInt(event.target.value, 10)
                                                        );
                                                        setQuizPage(0);
                                                    }}
                                                    sx={{
                                                        borderTop: `1px solid ${theme.palette.divider}`,
                                                        bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.5)",
                                                    }}
                                                />
                                            </TableContainer>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </Box>
                        ) : (
                            <Box sx={{ textAlign: "center", py: 5 }}>
                                <Typography variant="h6" color={theme.palette.text.secondary}>
                                    No quiz results found.
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <Box
                        sx={{
                            p: 2,
                            bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.5)",
                            borderTop: `1px solid ${theme.palette.divider}`,
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={() => setQuizModalOpen(false)}
                            sx={{
                                minWidth: 120,
                                borderRadius: "12px",
                                padding: "10px 24px",
                                fontWeight: "600",
                                textTransform: "none",
                                background: theme.palette.mode === 'light'
                                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                    : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                "&:hover": {
                                    background: theme.palette.mode === 'light'
                                        ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                        : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)",
                                },
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>
            {/* Login Details Modal */}
            <Modal open={loginModalOpen} onClose={() => setLoginModalOpen(false)}>
                <Box
                    sx={{
                        p: 0,
                        bgcolor: theme.palette.background.paper,
                        mx: "auto",
                        mt: "3%",
                        mb: "3%",
                        width: "90%",
                        maxWidth: 900,
                        maxHeight: "90vh",
                        borderRadius: "20px",
                        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        "&::-webkit-scrollbar": {
                            width: "10px",
                            height: "10px",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                            borderRadius: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                            borderRadius: "6px",
                            border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            background: theme.palette.mode === 'dark' ? '#64748b' : '#64748b',
                        },
                        // Custom scrollbar for Firefox
                        scrollbarWidth: "thin",
                        scrollbarColor: theme.palette.mode === 'dark' ? '#475569 #2d3748' : '#94a3b8 #f1f5f9',
                    }}

                >
                    <Box
                        sx={{
                            p: 3,
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                                Login Details for {loginDetails?.student_name} (
                                {loginDetails?.email})
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
                                Client Code: {loginDetails?.client_code}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ p: 3, overflowY: "auto", flex: 1 }}>
                        {loginDetails ? (
                            <Box>
                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(3, 1fr)",
                                        gap: 2,
                                        mb: 3,
                                    }}
                                >
                                    <Paper
                                        sx={{
                                            p: 2,
                                            bgcolor: theme.palette.mode === 'light' ? "#e3f2fd" : "rgba(25, 118, 210, 0.2)",
                                            borderRadius: "8px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>Total Logins</Typography>
                                        <Typography variant="h6" sx={{ fontWeight: "700", color: "#1976d2" }}>
                                            {loginDetails.total_logins}
                                        </Typography>
                                    </Paper>
                                    <Paper
                                        sx={{
                                            p: 2,
                                            bgcolor: theme.palette.mode === 'light' ? "#e8f5e9" : "rgba(76, 175, 80, 0.2)",
                                            borderRadius: "8px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>Total Duration (mins)</Typography>
                                        <Typography variant="h6" sx={{ fontWeight: "700", color: "#4caf50" }}>
                                            {loginDetails.total_duration_minutes.toFixed(2)}
                                        </Typography>
                                    </Paper>
                                    <Paper
                                        sx={{
                                            p: 2,
                                            bgcolor: theme.palette.mode === 'light' ? "#ffebee" : "rgba(244, 67, 54, 0.2)",
                                            borderRadius: "8px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>Last Login</Typography>
                                        <Typography variant="h6" sx={{ fontWeight: "700", color: "#f44336" }}>
                                            {loginDetails.last_login
                                                ? new Date(loginDetails.last_login).toLocaleString()
                                                : "N/A"}
                                        </Typography>
                                    </Paper>
                                </Box>
                                <Typography variant="h6" sx={{ mb: 2, fontWeight: "600", color: theme.palette.text.primary }}>
                                    Login Sessions
                                </Typography>
                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        marginTop: "16px",
                                        borderRadius: "12px",
                                        boxShadow: "none",
                                        border: `1px solid ${theme.palette.divider}`,
                                        backgroundColor: theme.palette.background.paper,
                                    }}
                                >
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: theme.palette.mode === 'light' ? "#f8f9ff" : "rgba(55, 65, 81, 0.5)" }}>
                                                <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Login Time</TableCell>
                                                <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Logout Time</TableCell>
                                                <TableCell sx={{ fontWeight: "600", color: theme.palette.text.primary }}>Duration (mins)</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {loginDetails.sessions
                                                .sort(
                                                    (a, b) =>
                                                        new Date(b.login_time) - new Date(a.login_time)
                                                )
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((session, index) => (
                                                    <TableRow
                                                        key={index}
                                                        sx={{ "&:hover": { bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.3)" } }}
                                                    >
                                                        <TableCell sx={{ color: theme.palette.text.primary }}>{new Date(session.login_time).toLocaleString()}</TableCell>
                                                        <TableCell sx={{ color: theme.palette.text.primary }}>
                                                            {session.logout_time
                                                                ? new Date(
                                                                    session.logout_time
                                                                ).toLocaleString()
                                                                : "Still logged in"}
                                                        </TableCell>
                                                        <TableCell sx={{ color: theme.palette.text.primary }}>{session.duration_minutes.toFixed(2)}</TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={loginDetails.sessions.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={(event, newPage) => setPage(newPage)}
                                        onRowsPerPageChange={(event) => {
                                            setRowsPerPage(parseInt(event.target.value, 10));
                                            setPage(0);
                                        }}
                                        sx={{
                                            borderTop: `1px solid ${theme.palette.divider}`,
                                            bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.5)",
                                        }}
                                    />
                                </TableContainer>
                            </Box>
                        ) : (
                            <Box sx={{ textAlign: "center", py: 5 }}>
                                <Typography variant="h6" color={theme.palette.text.secondary}>
                                    No login details found.
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <Box
                        sx={{
                            p: 2,
                            bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.5)",
                            borderTop: `1px solid ${theme.palette.divider}`,
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 2,
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={handleExportLoginDetails}
                            disabled={!loginDetails}
                            startIcon={
                                <i
                                    className="bi bi-download"
                                    style={{ fontSize: "1.2rem" }}
                                ></i>
                            }
                            sx={{
                                minWidth: 120,
                                borderRadius: "12px",
                                padding: "10px 24px",
                                fontWeight: "600",
                                textTransform: "none",
                                color: "#667eea",
                                borderColor: "#667eea",
                                "&:hover": {
                                    background: theme.palette.mode === 'light' ? "rgba(102, 126, 234, 0.08)" : "rgba(132, 144, 255, 0.08)",
                                    borderColor: "#667eea",
                                },
                                "&.Mui-disabled": {
                                    color: theme.palette.text.secondary,
                                    borderColor: theme.palette.divider,
                                },
                            }}
                        >
                            Export
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => setLoginModalOpen(false)}
                            sx={{
                                minWidth: 120,
                                borderRadius: "12px",
                                padding: "10px 24px",
                                fontWeight: "600",
                                textTransform: "none",
                                background: theme.palette.mode === 'light'
                                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                    : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                "&:hover": {
                                    background: theme.palette.mode === 'light'
                                        ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                        : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)",
                                },
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>
            {/* Delete Student Dialog */}
            <Dialog
                open={deleteDialogOpen}
                onClose={closeDeleteDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: "12px",
                        padding: "10px",
                        backgroundColor: theme.palette.background.paper,
                    },
                }}
            >
                <DialogTitle
                    id="alert-dialog-title"
                    sx={{
                        fontWeight: "bold",
                        color: "error.main",
                        fontSize: "1.3rem",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <DeleteIcon sx={{ color: "error.main", mr: 1 }} />
                    Delete Student
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                        <Typography variant="body1" sx={{ fontWeight: "medium", color: theme.palette.text.primary }}>
                            Are you sure you want to delete {studentToDelete?.name}? <br />
                            This action cannot be undone.
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
                    <Button
                        onClick={closeDeleteDialog}
                        variant="outlined"
                        color="inherit"
                        sx={{
                            borderColor: theme.palette.divider,
                            padding: "8px 20px",
                            fontSize: "0.9rem",
                            textTransform: "none",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDeleteStudent}
                        variant="contained"
                        color="error"
                        startIcon={<DeleteIcon />}
                        sx={{
                            boxShadow: "none",
                            padding: "8px 20px",
                            fontSize: "0.9rem",
                            textTransform: "none",
                        }}
                    >
                        Delete Permanently
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Edit Student Modal */}
            <Modal open={editModalOpen} onClose={closeEditModal}>
                <Box
                    sx={{
                        p: 0,
                        bgcolor: theme.palette.background.paper,
                        mx: "auto",
                        mt: "3%",
                        mb: "3%",
                        width: "90%",
                        maxWidth: 500,
                        maxHeight: "90vh",
                        borderRadius: "20px",
                        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box
                        sx={{
                            p: 3,
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                            Edit Student
                        </Typography>
                    </Box>
                    <Box sx={{ p: 3, overflowY: "auto", flex: 1 }}>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Name"
                            name="student_name"
                            value={formData.student_name}
                            onChange={handleFormChange}
                            error={!!formErrors.student_name}
                            helperText={formErrors.student_name}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Email"
                            name="student_email"
                            value={formData.student_email}
                            onChange={handleFormChange}
                            error={!!formErrors.student_email}
                            helperText={formErrors.student_email}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="New Password (leave blank to keep current)"
                            name="password"
                            type="password"
                            value={formData.password}
                            onChange={handleFormChange}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Confirm Password"
                            name="confirmPassword"
                            type="password"
                            value={formData.confirmPassword}
                            onChange={handleFormChange}
                            error={!!formErrors.confirmPassword}
                            helperText={formErrors.confirmPassword}
                        />
                    </Box>
                    <Box
                        sx={{
                            p: 2,
                            bgcolor: theme.palette.mode === 'light' ? "#f5f5f5" : "rgba(55, 65, 81, 0.5)",
                            borderTop: `1px solid ${theme.palette.divider}`,
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 2,
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={closeEditModal}
                            sx={{
                                minWidth: 120,
                                borderRadius: "12px",
                                padding: "10px 24px",
                                fontWeight: "600",
                                textTransform: "none",
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleEditSubmit}
                            sx={{
                                minWidth: 120,
                                borderRadius: "12px",
                                padding: "10px 24px",
                                fontWeight: "600",
                                textTransform: "none",
                                background: theme.palette.mode === 'light'
                                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                    : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                "&:hover": {
                                    background: theme.palette.mode === 'light'
                                        ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                        : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)",
                                },
                            }}
                        >
                            Save
                        </Button>
                    </Box>
                </Box>
            </Modal>
            {/* Assign Folder Modal */}
            <Dialog
                open={modalOpen}
                onClose={handleCloseModal}
                PaperProps={{
                    style: {
                        borderRadius: "20px",
                        padding: "10px",
                        minWidth: "400px",
                        maxWidth: "50vw",
                        backgroundColor: theme.palette.background.paper,
                    },
                }}
            >
                <DialogTitle
                    style={{
                        fontSize: "1.8rem",
                        fontWeight: "800",
                        background: theme.palette.mode === 'light'
                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        paddingBottom: "10px",
                        borderBottom: `2px solid ${theme.palette.divider}`,
                    }}
                >
                    <i
                        className="bi bi-folder-plus"
                        style={{ marginRight: "10px" }}
                    ></i>
                    Assign Course to {selectedStudent?.name}
                </DialogTitle>
                <DialogContent style={{ paddingTop: "24px" }}>
                    <DialogContentText
                        style={{
                            marginBottom: "24px",
                            color: theme.palette.text.secondary,
                            fontSize: "1.05rem",
                            lineHeight: 1.6,
                        }}
                    >
                        Select one or more courses to assign to {selectedStudent?.name}.
                    </DialogContentText>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel
                            id="folder-select-label"
                            sx={{ fontWeight: "600", color: theme.palette.text.primary }}
                        >
                            Select Course
                        </InputLabel>
                        <Select
                            labelId="folder-select-label"
                            label="Select Folder"
                            multiple
                            value={selectedFolders.map((f) => f.name)}
                            onChange={(e) => {
                                const selectedNames = e.target.value;
                                if (selectedNames.includes("select-all")) {
                                    const unassignedFolders = folders.filter(
                                        (f) =>
                                            !selectedStudent?.assigned_folders.some(
                                                (assigned) => assigned.name === f.name
                                            )
                                    );
                                    if (selectedFolders.length === unassignedFolders.length) {
                                        setSelectedFolders([]);
                                    } else {
                                        setSelectedFolders(unassignedFolders);
                                    }
                                } else {
                                    const selectedFolders = folders.filter(
                                        (f) =>
                                            selectedNames.includes(f.name) &&
                                            !selectedStudent?.assigned_folders.some(
                                                (assigned) => assigned.name === f.name
                                            )
                                    );
                                    setSelectedFolders(selectedFolders);
                                }
                            }}
                            renderValue={(selected) => (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                    {selected.map((name) => {
                                        const folder = folders.find((f) => f.name === name);
                                        return (
                                            <Chip
                                                key={name}
                                                label={folder?.name}
                                                onDelete={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedFolders((prev) =>
                                                        prev.filter((f) => f.name !== name)
                                                    );
                                                }}
                                                onMouseDown={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "12px",
                                    border: `2px solid ${theme.palette.divider}`,
                                    background: theme.palette.background.paper,
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300, // Set max height for scrolling
                                        "&::-webkit-scrollbar": {
                                            width: "10px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                            borderRadius: "6px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                            borderRadius: "6px",
                                            border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            background: '#64748b',
                                        },
                                        // Firefox
                                        scrollbarWidth: "thin",
                                        scrollbarColor: theme.palette.mode === 'dark'
                                            ? '#475569 #2d3748'
                                            : '#94a3b8 #f1f5f9',
                                    },
                                },
                            }}

                        >
                            <MenuItem value="select-all">
                                <Checkbox
                                    checked={folders.every(
                                        (f) =>
                                            selectedStudent?.assigned_folders.some(
                                                (assigned) => assigned.name === f.name
                                            ) ||
                                            selectedFolders.some(
                                                (selected) => selected.name === f.name
                                            )
                                    )}
                                    indeterminate={
                                        selectedFolders.length > 0 &&
                                        !folders.every(
                                            (f) =>
                                                selectedStudent?.assigned_folders.some(
                                                    (assigned) => assigned.name === f.name
                                                ) ||
                                                selectedFolders.some(
                                                    (selected) => selected.name === f.name
                                                )
                                        )
                                    }
                                />
                                <ListItemText primary="Select All" />
                            </MenuItem>
                            {folders.map((folder) => {
                                const isAssigned = selectedStudent?.assigned_folders.some(
                                    (assigned) => assigned.name === folder.name
                                );
                                return (
                                    <MenuItem
                                        key={folder.id}
                                        value={folder.name}
                                        disabled={isAssigned}
                                        sx={{
                                            "&.Mui-disabled": {
                                                color: theme.palette.text.secondary,
                                            },
                                        }}
                                    >
                                        <Checkbox
                                            checked={
                                                selectedFolders.some((f) => f.name === folder.name) ||
                                                isAssigned
                                            }
                                        />
                                        <ListItemText primary={folder.name} />
                                        {isAssigned && (
                                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                                (Already Assigned)
                                            </Typography>
                                        )}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={handleCloseModal}
                        sx={{
                            color: theme.palette.text.secondary,
                            padding: "10px 24px",
                            fontSize: "1rem",
                            fontWeight: "600",
                            borderRadius: "10px",
                            textTransform: "none",
                            "&:hover": {
                                background: theme.palette.mode === 'light' ? "#f3f4f6" : "rgba(55, 65, 81, 0.5)",
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleAssign}
                        disabled={selectedFolders.length === 0}
                        variant="contained"
                        sx={{
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                            color: "white",
                            padding: "10px 28px",
                            fontSize: "1rem",
                            fontWeight: "700",
                            borderRadius: "10px",
                            textTransform: "none",
                            boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                            "&:hover": {
                                background: theme.palette.mode === 'light'
                                    ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                    : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)",
                                boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
                            },
                            "&.Mui-disabled": {
                                background: theme.palette.mode === 'light' ? "#d1d5db" : "rgba(209, 213, 219, 0.5)",
                                color: "white",
                                opacity: 0.6,
                            },
                        }}
                    >
                        <i
                            className="bi bi-check-circle"
                            style={{ marginRight: "8px" }}
                        ></i>
                        Assign
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Remove Folder Modal */}
            <Dialog
                open={removeModalOpen}
                onClose={handleCloseRemoveModal}
                PaperProps={{
                    style: {
                        borderRadius: "20px",
                        padding: "10px",
                        minWidth: "400px",
                        maxWidth: "50vw",
                        backgroundColor: theme.palette.background.paper,
                    },
                }}
            >
                <DialogTitle
                    style={{
                        fontSize: "1.8rem",
                        fontWeight: "800",
                        background: theme.palette.mode === 'light'
                            ? "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)"
                            : "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        paddingBottom: "10px",
                        borderBottom: `2px solid ${theme.palette.divider}`,
                    }}
                >
                    <i
                        className="bi bi-folder-minus"
                        style={{ marginRight: "10px" }}
                    ></i>
                    Remove course from {selectedStudent?.name}
                </DialogTitle>
                <DialogContent style={{ paddingTop: "24px" }}>
                    <DialogContentText
                        style={{
                            marginBottom: "24px",
                            color: theme.palette.text.secondary,
                            fontSize: "1.05rem",
                            lineHeight: 1.6,
                        }}
                    >
                        Select a course to remove from {selectedStudent?.name}.
                    </DialogContentText>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel sx={{ fontWeight: "600", color: theme.palette.text.primary }}>
                            Select Course
                        </InputLabel>
                        <Select
                            labelId="remove-courses-select-label"
                            label="Select Courses"
                            multiple
                            value={selectedFolders.map((f) => f.name)}
                            onChange={(e) => {
                                const selectedNames = e.target.value;
                                if (selectedNames.includes("select-all")) {
                                    if (
                                        selectedFolders.length ===
                                        selectedStudent?.assigned_folders.length
                                    ) {
                                        setSelectedFolders([]);
                                    } else {
                                        setSelectedFolders([
                                            ...selectedStudent?.assigned_folders,
                                        ]);
                                    }
                                } else {
                                    const selectedFolders =
                                        selectedStudent?.assigned_folders.filter((f) =>
                                            selectedNames.includes(f.name)
                                        );
                                    setSelectedFolders(selectedFolders);
                                }
                            }}
                            renderValue={(selected) => (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                    {selected.map((name) => {
                                        const folder = selectedStudent?.assigned_folders.find(
                                            (f) => f.name === name
                                        );
                                        return (
                                            <Chip
                                                key={name}
                                                label={folder?.name}
                                                onDelete={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedFolders((prev) =>
                                                        prev.filter((f) => f.name !== name)
                                                    );
                                                }}
                                                onMouseDown={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "12px",
                                    border: `2px solid ${theme.palette.divider}`,
                                    background: theme.palette.background.paper,
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300, // Set max height for scrolling
                                        "&::-webkit-scrollbar": {
                                            width: "10px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                            borderRadius: "6px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                            borderRadius: "6px",
                                            border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            background: '#64748b',
                                        },
                                        // Firefox
                                        scrollbarWidth: "thin",
                                        scrollbarColor: theme.palette.mode === 'dark'
                                            ? '#475569 #2d3748'
                                            : '#94a3b8 #f1f5f9',
                                    },
                                },
                            }}
                        >
                            <MenuItem value="select-all">
                                <Checkbox
                                    checked={
                                        selectedFolders.length > 0 &&
                                        selectedFolders.length ===
                                        selectedStudent?.assigned_folders.length
                                    }
                                    indeterminate={
                                        selectedFolders.length > 0 &&
                                        selectedFolders.length <
                                        selectedStudent?.assigned_folders.length
                                    }
                                />
                                <ListItemText primary="Select All" />
                            </MenuItem>
                            {selectedStudent?.assigned_folders.map((folder) => (
                                <MenuItem key={folder.id} value={folder.name}>
                                    <Checkbox
                                        checked={selectedFolders.some(
                                            (f) => f.name === folder.name
                                        )}
                                    />
                                    <ListItemText primary={folder.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={handleCloseRemoveModal}
                        sx={{
                            color: theme.palette.text.secondary,
                            padding: "10px 24px",
                            fontSize: "1rem",
                            fontWeight: "600",
                            borderRadius: "10px",
                            textTransform: "none",
                            "&:hover": {
                                background: theme.palette.mode === 'light' ? "#f3f4f6" : "rgba(55, 65, 81, 0.5)",
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleRemove}
                        disabled={selectedFolders.length === 0}
                        variant="contained"
                        sx={{
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)"
                                : "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                            color: "white",
                            padding: "10px 28px",
                            fontSize: "1rem",
                            fontWeight: "700",
                            borderRadius: "10px",
                            textTransform: "none",
                            boxShadow: "0 4px 15px rgba(244, 67, 54, 0.4)",
                            "&:hover": {
                                background: theme.palette.mode === 'light'
                                    ? "linear-gradient(135deg, #d32f2f 0%, #f44336 100%)"
                                    : "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
                                boxShadow: "0 6px 20px rgba(244, 67, 54, 0.5)",
                            },
                            "&.Mui-disabled": {
                                background: theme.palette.mode === 'light' ? "#d1d5db" : "rgba(209, 213, 219, 0.5)",
                                color: "white",
                                opacity: 0.6,
                            },
                        }}
                    >
                        <i className="bi bi-trash" style={{ marginRight: "8px" }}></i>
                        Remove Selected
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={assignFolderModalOpen}
                onClose={handleCloseAssignFolderModal}
                PaperProps={{
                    style: {
                        borderRadius: "20px",
                        padding: "10px",
                        minWidth: "400px",
                        maxWidth: "50vw",
                        backgroundColor: theme.palette.background.paper,
                    },
                }}
            >
                <DialogTitle
                    style={{
                        fontSize: "1.8rem",
                        fontWeight: "800",
                        background: theme.palette.mode === 'light'
                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        paddingBottom: "10px",
                        borderBottom: `2px solid ${theme.palette.divider}`,
                    }}
                >
                    <i
                        className="bi bi-people-fill"
                        style={{ marginRight: "10px" }}
                    ></i>
                    Assign {selectedFolderForAssign?.name} to Students
                </DialogTitle>
                <DialogContent style={{ paddingTop: "24px" }}>
                    <DialogContentText
                        style={{
                            marginBottom: "24px",
                            color: theme.palette.text.secondary,
                            fontSize: "1.05rem",
                            lineHeight: 1.6,
                        }}
                    >
                        Select students to assign the course.
                    </DialogContentText>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel
                            id="student-select-label"
                            sx={{ fontWeight: "600", color: theme.palette.text.primary }}
                        >
                            Select students
                        </InputLabel>
                        <Select
                            labelId="student-select-label"
                            label="Select students"
                            multiple
                            value={selectedStudentsForFolder.map((s) => s.id)}
                            onChange={(e) => {
                                const selectedIds = e.target.value;
                                if (selectedIds.includes("select-all")) {
                                    const allUnassignedStudents = students.filter(
                                        (s) =>
                                            !s.assigned_folders.some(
                                                (f) => f.id === selectedFolderForAssign?.id
                                            )
                                    );
                                    if (
                                        selectedStudentsForFolder.length ===
                                        allUnassignedStudents.length
                                    ) {
                                        setSelectedStudentsForFolder([]);
                                    } else {
                                        setSelectedStudentsForFolder(allUnassignedStudents);
                                    }
                                } else {
                                    const selectedStudents = students.filter((s) =>
                                        selectedIds.includes(s.id)
                                    );
                                    setSelectedStudentsForFolder(selectedStudents);
                                }
                            }}
                            renderValue={(selected) => (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                    {selected.map((id) => {
                                        if (id === "select-all") {
                                            return <Chip key="select-all" label="All" />;
                                        }
                                        const student = students.find((s) => s.id === id);
                                        return (
                                            <Chip
                                                key={id}
                                                label={student?.name}
                                                onDelete={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedStudentsForFolder((prev) =>
                                                        prev.filter((s) => s.id !== id)
                                                    );
                                                }}
                                                onMouseDown={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "12px",
                                    border: `2px solid ${theme.palette.divider}`,
                                    background: theme.palette.background.paper,
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300, // Set max height for scrolling
                                        "&::-webkit-scrollbar": {
                                            width: "10px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                            borderRadius: "6px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                            borderRadius: "6px",
                                            border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            background: '#64748b',
                                        },
                                        // Firefox
                                        scrollbarWidth: "thin",
                                        scrollbarColor: theme.palette.mode === 'dark'
                                            ? '#475569 #2d3748'
                                            : '#94a3b8 #f1f5f9',
                                    },
                                },
                            }}
                        >
                            <MenuItem value="select-all">
                                <Checkbox
                                    checked={students.every(
                                        (s) =>
                                            s.assigned_folders.some(
                                                (f) => f.id === selectedFolderForAssign?.id
                                            ) ||
                                            selectedStudentsForFolder.some(
                                                (selected) => selected.id === s.id
                                            )
                                    )}
                                    indeterminate={
                                        selectedStudentsForFolder.length > 0 &&
                                        !students.every(
                                            (s) =>
                                                s.assigned_folders.some(
                                                    (f) => f.id === selectedFolderForAssign?.id
                                                ) ||
                                                selectedStudentsForFolder.some(
                                                    (selected) => selected.id === s.id
                                                )
                                        )
                                    }
                                />
                                <ListItemText primary="Select All" />
                            </MenuItem>
                            {students.map((student) => {
                                const isAssigned = student.assigned_folders.some(
                                    (folder) => folder.id === selectedFolderForAssign?.id
                                );
                                return (
                                    <MenuItem
                                        key={student.id}
                                        value={student.id}
                                        disabled={isAssigned}
                                        sx={{
                                            "&.Mui-disabled": {
                                                color: theme.palette.text.secondary,
                                            },
                                        }}
                                    >
                                        <Checkbox
                                            checked={
                                                selectedStudentsForFolder.some(
                                                    (s) => s.id === student.id
                                                ) || isAssigned
                                            }
                                        />
                                        <ListItemText primary={student.name} />
                                        {isAssigned && (
                                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                                (Already Assigned)
                                            </Typography>
                                        )}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={handleCloseAssignFolderModal}
                        sx={{
                            color: theme.palette.text.secondary,
                            padding: "10px 24px",
                            fontSize: "1rem",
                            fontWeight: "600",
                            borderRadius: "10px",
                            textTransform: "none",
                            "&:hover": {
                                background: theme.palette.mode === 'light' ? "#f3f4f6" : "rgba(55, 65, 81, 0.5)",
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleAssignFolderSubmit}
                        disabled={selectedStudentsForFolder.length === 0}
                        variant="contained"
                        sx={{
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                            color: "white",
                            padding: "10px 28px",
                            fontSize: "1rem",
                            fontWeight: "700",
                            borderRadius: "10px",
                            textTransform: "none",
                            boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                            "&:hover": {
                                background: theme.palette.mode === 'light'
                                    ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                    : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)",
                                boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
                            },
                            "&.Mui-disabled": {
                                background: theme.palette.mode === 'light' ? "#d1d5db" : "rgba(209, 213, 219, 0.5)",
                                color: "white",
                                opacity: 0.6,
                            },
                        }}
                    >
                        <i
                            className="bi bi-check-circle"
                            style={{ marginRight: "8px" }}
                        ></i>
                        Bulk Assign
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={removeFolderModalOpen}
                onClose={handleCloseBulkRemoveModal}
                PaperProps={{
                    style: {
                        borderRadius: "20px",
                        padding: "10px",
                        minWidth: "400px",
                        maxWidth: "50vw",
                        backgroundColor: theme.palette.background.paper,
                    },
                }}
            >
                <DialogTitle
                    style={{
                        fontSize: "1.8rem",
                        fontWeight: "800",
                        background: theme.palette.mode === 'light'
                            ? "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)"
                            : "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        paddingBottom: "10px",
                        borderBottom: `2px solid ${theme.palette.divider}`,
                    }}
                >
                    <i
                        className="bi bi-folder-minus"
                        style={{ marginRight: "10px" }}
                    ></i>
                    Remove {selectedFolderForRemove?.name} from Students
                </DialogTitle>
                <DialogContent style={{ paddingTop: "24px", }}>


                    <DialogContentText
                        style={{
                            marginBottom: "24px",
                            color: theme.palette.text.secondary,
                            fontSize: "1.05rem",
                            lineHeight: 1.6,
                        }}
                    >
                        Select students to remove the course from.
                    </DialogContentText>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel
                            id="student-remove-select-label"
                            sx={{ fontWeight: "600", color: theme.palette.text.primary }}
                        >
                            Select Students
                        </InputLabel>
                        <Select
                            labelId="student-remove-select-label"
                            label="Select Students"
                            multiple
                            value={selectedStudentsForRemove.map((s) => s.id)}
                            onChange={(e) => {
                                const selectedIds = e.target.value;
                                if (selectedIds.includes("select-all")) {
                                    if (
                                        selectedStudentsForRemove.length ===
                                        selectedFolderForRemove?.assigned_students.length
                                    ) {
                                        setSelectedStudentsForRemove([]);
                                    } else {
                                        setSelectedStudentsForRemove([
                                            ...selectedFolderForRemove?.assigned_students,
                                        ]);
                                    }
                                } else {
                                    const selectedStudents =
                                        selectedFolderForRemove?.assigned_students.filter((s) =>
                                            selectedIds.includes(s.id)
                                        );
                                    setSelectedStudentsForRemove(selectedStudents);
                                }
                            }}
                            renderValue={(selected) => (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                    {selected.map((id) => {
                                        const student =
                                            selectedFolderForRemove?.assigned_students.find(
                                                (s) => s.id === id
                                            );
                                        return (
                                            <Chip
                                                key={id}
                                                label={student?.name}
                                                onDelete={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedStudentsForRemove((prev) =>
                                                        prev.filter((s) => s.id !== id)
                                                    );
                                                }}
                                                onMouseDown={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "12px",
                                    border: `2px solid ${theme.palette.divider}`,
                                    background: theme.palette.background.paper,
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                        "&::-webkit-scrollbar": {
                                            width: "10px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                            borderRadius: "6px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                            borderRadius: "6px",
                                            border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            background: '#64748b',
                                        },
                                        scrollbarWidth: "thin",
                                        scrollbarColor: theme.palette.mode === 'dark'
                                            ? '#475569 #2d3748'
                                            : '#94a3b8 #f1f5f9',
                                    },
                                },
                            }}
                        >
                            <MenuItem value="select-all">
                                <Checkbox
                                    checked={
                                        selectedStudentsForRemove.length > 0 &&
                                        selectedStudentsForRemove.length ===
                                        selectedFolderForRemove?.assigned_students.length
                                    }
                                    indeterminate={
                                        selectedStudentsForRemove.length > 0 &&
                                        selectedStudentsForRemove.length <
                                        selectedFolderForRemove?.assigned_students.length
                                    }
                                />
                                <ListItemText primary="Select All" />
                            </MenuItem>
                            {selectedFolderForRemove?.assigned_students.map((student) => (
                                <MenuItem key={student.id} value={student.id}>
                                    <Checkbox
                                        checked={selectedStudentsForRemove.some(
                                            (s) => s.id === student.id
                                        )}
                                    />
                                    <ListItemText primary={student.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={handleCloseBulkRemoveModal}
                        sx={{
                            color: theme.palette.text.secondary,
                            padding: "10px 24px",
                            fontSize: "1rem",
                            fontWeight: "600",
                            borderRadius: "10px",
                            textTransform: "none",
                            "&:hover": {
                                background: theme.palette.mode === 'light' ? "#f3f4f6" : "rgba(55, 65, 81, 0.5)",
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleBulkRemoveFolderSubmit}
                        disabled={selectedStudentsForRemove.length === 0}
                        variant="contained"
                        sx={{
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)"
                                : "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                            color: "white",
                            padding: "10px 28px",
                            fontSize: "1rem",
                            fontWeight: "700",
                            borderRadius: "10px",
                            textTransform: "none",
                            boxShadow: "0 4px 15px rgba(244, 67, 54, 0.4)",
                            "&:hover": {
                                background: theme.palette.mode === 'light'
                                    ? "linear-gradient(135deg, #d32f2f 0%, #f44336 100%)"
                                    : "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
                                boxShadow: "0 6px 20px rgba(244, 67, 54, 0.5)",
                            },
                            "&.Mui-disabled": {
                                background: theme.palette.mode === 'light' ? "#d1d5db" : "rgba(209, 213, 219, 0.5)",
                                color: "white",
                                opacity: 0.6,
                            },
                        }}
                    >
                        <i className="bi bi-trash" style={{ marginRight: "8px" }}></i>
                        Bulk Remove
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{
                        width: "100%",
                        fontSize: "1rem",
                        fontWeight: "600",
                        borderRadius: "12px",
                        boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
                        bgcolor: theme.palette.background.paper,
                    }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Modal open={infoModalOpen} onClose={() => setInfoModalOpen(false)}>
                <Box
                    sx={{
                        p: 0,
                        bgcolor: theme.palette.background.paper,
                        mx: "auto",
                        mt: "3%",
                        mb: "3%",
                        width: "90%",
                        maxWidth: 800,
                        maxHeight: "90vh",
                        borderRadius: "16px",
                        boxShadow: "0 24px 48px rgba(0, 0, 0, 0.15)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        "&::-webkit-scrollbar": {
                            width: "10px",
                            height: "10px",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                            borderRadius: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                            borderRadius: "6px",
                            border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            background: theme.palette.mode === 'dark' ? '#64748b' : '#64748b',
                        },
                        // Custom scrollbar for Firefox
                        scrollbarWidth: "thin",
                        scrollbarColor: theme.palette.mode === 'dark' ? '#475569 #2d3748' : '#94a3b8 #f1f5f9',
                    }}

                >
                    {/* Header */}
                    <Box
                        sx={{
                            p: 3.5,
                            background: theme.palette.mode === 'light'
                                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Box>
                            <Typography variant="h5" sx={{ fontWeight: "700", mb: 0.5 }}>
                                User Guide
                            </Typography>
                            <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                Control Panel
                            </Typography>
                        </Box>
                    </Box>
                    {/* Content */}
                    <Box sx={{ p: 4, overflowY: "auto", flex: 1 }}>
                        {/* Student Management Section */}
                        <Box sx={{ mb: 4 }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "10px",
                                        background: theme.palette.mode === 'light'
                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mr: 2,
                                    }}
                                >
                                    <i
                                        className="bi bi-people-fill"
                                        style={{ color: "white", fontSize: 20 }}
                                    ></i>
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "600", color: theme.palette.text.primary }}
                                >
                                    Student Management
                                </Typography>
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{ color: theme.palette.text.secondary, lineHeight: 1.7, pl: 7 }}
                            >
                                Use this tab to manage students. You can view, edit, delete,
                                and assign courses to students. Click the{" "}
                                <strong>three-dot menu</strong> to access actions for each
                                student.
                            </Typography>
                        </Box>
                        {/* Folders Management Section */}
                        <Box sx={{ mb: 4 }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "10px",
                                        background: theme.palette.mode === 'light'
                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mr: 2,
                                    }}
                                >
                                    <i
                                        className="bi bi-folder-fill"
                                        style={{ color: "white", fontSize: 20 }}
                                    ></i>
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "600", color: theme.palette.text.primary }}
                                >
                                    Courses Management
                                </Typography>
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{ color: theme.palette.text.secondary, lineHeight: 1.7, pl: 7 }}
                            >
                                Use this tab to manage courses. You can search for courses,
                                view assigned students, and bulk assign course to multiple
                                students.
                            </Typography>
                        </Box>
                        {/* View Results Section */}
                        <Box sx={{ mb: 4 }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "10px",
                                        background: theme.palette.mode === 'light'
                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mr: 2,
                                    }}
                                >
                                    <VisibilityIcon sx={{ color: "white", fontSize: 20 }} />
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "600", color: theme.palette.text.primary }}
                                >
                                    View Results
                                </Typography>
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{ color: theme.palette.text.secondary, lineHeight: 1.7, pl: 7 }}
                            >
                                Click the <strong>View Result</strong> option in the student
                                menu to see quiz results for a student. Results are organized
                                by course and quiz.
                            </Typography>
                        </Box>
                        {/* Login Details Section */}
                        <Box sx={{ mb: 4 }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "10px",
                                        background: theme.palette.mode === 'light'
                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mr: 2,
                                    }}
                                >
                                    <LoginIcon sx={{ color: "white", fontSize: 20 }} />
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "600", color: theme.palette.text.primary }}
                                >
                                    Login Details
                                </Typography>
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{ color: theme.palette.text.secondary, lineHeight: 1.7, pl: 7 }}
                            >
                                Click the <strong>Login Details</strong> option in the student
                                menu to view login history, total logins, and session
                                durations.
                            </Typography>
                        </Box>
                        {/* Assign Folders Section */}
                        <Box sx={{ mb: 4 }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "10px",
                                        background: theme.palette.mode === 'light'
                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mr: 2,
                                    }}
                                >
                                    <AssignmentIcon sx={{ color: "white", fontSize: 20 }} />
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "600", color: theme.palette.text.primary }}
                                >
                                    Assign Courses
                                </Typography>
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{ color: theme.palette.text.secondary, lineHeight: 1.7, pl: 7 }}
                            >
                                Use the <strong>Assign Course</strong> option to assign
                                courses to a student. You can also bulk assign multiple
                                courses to a particular students.
                            </Typography>
                        </Box>

                        {/* Edit Student Section */}
                        <Box sx={{ mb: 4 }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                                <Box
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "10px",
                                        background: theme.palette.mode === 'light'
                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                            : "linear-gradient(135deg, #818cf8 0%, #9333ea 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mr: 2,
                                    }}
                                >
                                    <EditIcon sx={{ color: "white", fontSize: 20 }} />
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: "600",
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    Edit Student
                                </Typography>
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: theme.palette.text.secondary,
                                    lineHeight: 1.7,
                                    pl: 7,
                                }}
                            >
                                Use the <strong>Edit Student</strong> option to update student
                                details like name, email, and password.
                            </Typography>
                        </Box>

                        {/* Pro Tips */}
                        <Box
                            sx={{
                                p: 3,
                                borderRadius: "12px",
                                bgcolor: theme.palette.background.paper,
                                border: `1px solid ${theme.palette.divider}`,
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: "600", color: theme.palette.text.primary,
                                    mb: 2,
                                }}
                            >
                                💡 Quick Tips
                            </Typography>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: theme.palette.text.secondary,
                                        lineHeight: 1.7,
                                    }}
                                >
                                    • Use the search bar to quickly find students or courses.
                                </Typography>
                                <Typography
                                    sx={{
                                        color: theme.palette.text.secondary,
                                        lineHeight: 1.7,
                                    }}
                                >
                                    • Use the filter dropdown to narrow down students by
                                    assigned courses.
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: theme.palette.text.secondary,
                                        lineHeight: 1.7,
                                    }}
                                >
                                    • Click the three-dot menu for more actions on a student.
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Footer */}
                    <Box
                        sx={{
                            p: 3,
                            bgcolor: theme.palette.background.paper,
                            borderTop: `1px solid ${theme.palette.divider}`,
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={() => setInfoModalOpen(false)}
                            sx={{
                                minWidth: 120,
                                borderRadius: "10px",
                                padding: "10px 28px",
                                fontWeight: "600",
                                textTransform: "none",
                                background:
                                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                                    boxShadow: "0 6px 16px rgba(102, 126, 234, 0.4)",
                                },
                            }}
                        >
                            Got it
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Dialog
                open={removeFolderModalOpen}
                onClose={handleCloseBulkRemoveModal}
                PaperProps={{
                    style: {
                        borderRadius: "20px",
                        padding: "10px",
                        minWidth: "400px",
                        maxWidth: "50vw",
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                    },
                }}
            >
                <DialogTitle
                    style={{
                        fontSize: "1.8rem",
                        fontWeight: "800",
                        background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        paddingBottom: "10px",
                        borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <i
                        className="bi bi-folder-minus"
                        style={{ marginRight: "10px" }}
                    ></i>
                    Remove {selectedFolderForRemove?.name} from Students
                </DialogTitle>
                <DialogContent style={{ paddingTop: "24px" }}>
                    <DialogContentText
                        style={{
                            marginBottom: "24px",
                            color: theme.palette.text.secondary,
                            fontSize: "1.05rem",
                            lineHeight: 1.6,
                        }}
                    >
                        Select students to remove the course from.
                    </DialogContentText>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel
                            id="student-remove-select-label"
                            sx={{
                                fontWeight: "600",
                                color: theme.palette.text.primary,
                            }}
                        >
                            Select Students
                        </InputLabel>
                        <Select
                            labelId="student-remove-select-label"
                            label="Select Students"
                            multiple
                            value={selectedStudentsForRemove.map((s) => s.id)}
                            onChange={(e) => {
                                const selectedIds = e.target.value;
                                if (selectedIds.includes("select-all")) {
                                    if (
                                        selectedStudentsForRemove.length ===
                                        selectedFolderForRemove?.assigned_students.length
                                    ) {
                                        setSelectedStudentsForRemove([]);
                                    } else {
                                        setSelectedStudentsForRemove([
                                            ...selectedFolderForRemove?.assigned_students,
                                        ]);
                                    }
                                } else {
                                    const selectedStudents =
                                        selectedFolderForRemove?.assigned_students.filter((s) =>
                                            selectedIds.includes(s.id)
                                        );
                                    setSelectedStudentsForRemove(selectedStudents);
                                }
                            }}
                            renderValue={(selected) => (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                    {selected.map((id) => {
                                        const student =
                                            selectedFolderForRemove?.assigned_students.find(
                                                (s) => s.id === id
                                            );
                                        return (
                                            <Chip
                                                key={id}
                                                label={student?.name}
                                                onDelete={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedStudentsForRemove((prev) =>
                                                        prev.filter((s) => s.id !== id)
                                                    );
                                                }}
                                                onMouseDown={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "12px",
                                    border: `1px solid ${theme.palette.divider}`,
                                    background: theme.palette.background.paper,
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                        "&::-webkit-scrollbar": {
                                            width: "10px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                            borderRadius: "6px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                            borderRadius: "6px",
                                            border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            background: theme.palette.mode === 'dark' ? '#64748b' : '#64748b',
                                        },
                                        scrollbarWidth: "thin",
                                        scrollbarColor: theme.palette.mode === 'dark'
                                            ? '#475569 #2d3748'
                                            : '#94a3b8 #f1f5f9',
                                    },
                                },
                            }}
                        >
                            <MenuItem value="select-all">
                                <Checkbox
                                    checked={
                                        selectedStudentsForRemove.length > 0 &&
                                        selectedStudentsForRemove.length ===
                                        selectedFolderForRemove?.assigned_students.length
                                    }
                                    indeterminate={
                                        selectedStudentsForRemove.length > 0 &&
                                        selectedStudentsForRemove.length <
                                        selectedFolderForRemove?.assigned_students.length
                                    }
                                />
                                <ListItemText primary="Select All" />
                            </MenuItem>
                            {selectedFolderForRemove?.assigned_students.map((student) => (
                                <MenuItem key={student.id} value={student.id}>
                                    <Checkbox
                                        checked={selectedStudentsForRemove.some(
                                            (s) => s.id === student.id
                                        )}
                                    />
                                    <ListItemText primary={student.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={handleCloseBulkRemoveModal}
                        sx={{
                            color: theme.palette.text.secondary,
                            padding: "10px 24px",
                            fontSize: "1rem",
                            fontWeight: "600",
                            borderRadius: "10px",
                            textTransform: "none",
                            "&:hover": {
                                background: theme.palette.action.hover,
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleBulkRemoveFolderSubmit}
                        disabled={selectedStudentsForRemove.length === 0}
                        variant="contained"
                        sx={{
                            background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
                            color: "white",
                            padding: "10px 28px",
                            fontSize: "1rem",
                            fontWeight: "700",
                            borderRadius: "10px",
                            textTransform: "none",
                            boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                            "&:hover": {
                                background: theme.palette.mode === 'light'
                                    ? "linear-gradient(135deg, #764ba2 0%, #667eea 100%)"
                                    : "linear-gradient(135deg, #9333ea 0%, #818cf8 100%)",
                                boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
                            },
                            "&.Mui-disabled": {
                                background: theme.palette.mode === 'light' ? "#d1d5db" : "rgba(209, 213, 219, 0.5)",
                                color: "white",
                                opacity: 0.6,
                            },
                        }}
                    >
                        <i className="bi bi-trash" style={{ marginRight: "8px" }}></i>
                        Bulk Remove
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={exportQaModalOpen}
                onClose={() => {
                    setExportQaModalOpen(false);
                    setSelectedFoldersForExport([]);
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            maxHeight: 300, // Set max height for scrolling
                            "&::-webkit-scrollbar": {
                                width: "10px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                borderRadius: "6px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                borderRadius: "6px",
                                border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                background: '#64748b',
                            },
                            // Firefox
                            scrollbarWidth: "thin",
                            scrollbarColor: theme.palette.mode === 'dark'
                                ? '#475569 #2d3748'
                                : '#94a3b8 #f1f5f9',
                        },
                    },
                }}
            >
                <DialogTitle
                    style={{
                        fontSize: "1.8rem",
                        fontWeight: "800",
                        background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        paddingBottom: "10px",
                        borderBottom: "2px solid #e5e7eb",
                    }}
                >
                    <i
                        className="bi bi-download"
                        style={{ marginRight: "10px" }}
                    ></i>
                    Export Q/A from Courses
                </DialogTitle>
                <DialogContent style={{ paddingTop: "24px" }}>
                    <DialogContentText
                        style={{
                            marginBottom: "24px",
                            color: theme.palette.text.secondary,
                            fontSize: "1.05rem",
                            lineHeight: 1.6,
                        }}
                    >
                        Select one or more courses to export Q/A.
                    </DialogContentText>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                        <InputLabel
                            id="export-folder-select-label"
                            sx={{ color: theme.palette.text.primary, fontWeight: "700" }}
                        >
                            Select Courses
                        </InputLabel>
                        <Select
                            labelId="export-course-select-label"
                            label="Select Courses"
                            multiple
                            value={selectedFoldersForExport.map((f) => f.id)}
                            onChange={(e) => {
                                const selectedIds = e.target.value;
                                if (selectedIds.includes("select-all")) {
                                    // Toggle logic for "Select All"
                                    if (
                                        selectedFoldersForExport.length === folders.length
                                    ) {
                                        setSelectedFoldersForExport([]);
                                    } else {
                                        setSelectedFoldersForExport([...folders]);
                                    }
                                } else {
                                    const selectedFolders = folders.filter((f) =>
                                        selectedIds.includes(f.id)
                                    );
                                    setSelectedFoldersForExport(selectedFolders);
                                }
                            }}
                            renderValue={(selected) => (
                                <Box
                                    sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                                >
                                    {selected.map((id) => {
                                        const folder = folders.find((f) => f.id === id);
                                        return (
                                            <Chip
                                                key={id}
                                                label={folder?.name}
                                                onDelete={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedFoldersForExport((prev) =>
                                                        prev.filter((f) => f.id !== id)
                                                    );
                                                }}
                                                onMouseDown={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "12px",
                                    border: "2px solid #e0e7ff",
                                    background: "white",
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300, // Set max height for scrolling
                                        "&::-webkit-scrollbar": {
                                            width: "10px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9',
                                            borderRadius: "6px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: theme.palette.mode === 'dark' ? '#475569' : '#94a3b8',
                                            borderRadius: "6px",
                                            border: `2px solid ${theme.palette.mode === 'dark' ? '#2d3748' : '#f1f5f9'}`,
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            background: '#64748b',
                                        },
                                        // Firefox
                                        scrollbarWidth: "thin",
                                        scrollbarColor: theme.palette.mode === 'dark'
                                            ? '#475569 #2d3748'
                                            : '#94a3b8 #f1f5f9',
                                    },
                                },
                            }}
                        >
                            {/* Select All Option */}
                            <MenuItem value="select-all">
                                <Checkbox
                                    checked={
                                        selectedFoldersForExport.length > 0 &&
                                        selectedFoldersForExport.length === folders.length
                                    }
                                    indeterminate={
                                        selectedFoldersForExport.length > 0 &&
                                        selectedFoldersForExport.length < folders.length
                                    }
                                />
                                <ListItemText primary="Select All" />
                            </MenuItem>
                            {/* Folder Options */}
                            {folders.map((folder) => (
                                <MenuItem key={folder.id} value={folder.id}>
                                    <Checkbox
                                        checked={selectedFoldersForExport.some(
                                            (f) => f.id === folder.id
                                        )}
                                    />
                                    <ListItemText primary={folder.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={() => {
                            setExportQaModalOpen(false);
                            setSelectedFoldersForExport([]);
                        }}
                        sx={{
                            color: theme.palette.text.secondary,
                            padding: "10px 24px",
                            fontSize: "1rem",
                            fontWeight: "600",
                            borderRadius: "10px",
                            textTransform: "none",
                            "&:hover": {
                                background: theme.palette.action.hover,
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={async () => {
                            if (selectedFoldersForExport.length > 0) {
                                const folderIds = selectedFoldersForExport
                                    .map((f) => f.id)
                                    .join(",");
                                await handleExportFolder(folderIds);
                                setExportQaModalOpen(false);
                                setSelectedFoldersForExport([]);
                            }
                        }}
                        disabled={selectedFoldersForExport.length === 0}
                        variant="contained"
                        sx={{
                            background:
                                "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            color: "white",
                            padding: "10px 28px",
                            fontSize: "1rem",
                            fontWeight: "700",
                            borderRadius: "10px",
                            textTransform: "none",
                            boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                            "&:hover": {
                                background:
                                    "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                                boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
                            },
                            "&.Mui-disabled": {
                                background: "#d1d5db",
                                color: "white",
                                opacity: 0.6,
                            },
                        }}
                    >
                        <i
                            className="bi bi-check-circle"
                            style={{ marginRight: "8px" }}
                        ></i>
                        Export
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ControlPanel;
